import React, { useState, useRef, useEffect, SyntheticEvent } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  List,
  ListItem,
  FormControl,
  Select,
  Menu,
  MenuItem,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Tooltip,
  LinearProgress,
  ListItemText,
  Grid,
  Slider,
} from "@mui/material";
import withSpinner from "../../HOC/withSpinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectLabels,
  fetchProjectLabelById,
  addProjectLabels,
  editProjectLabel,
  deleteProjectLabel,
} from "../../store/slice/ProjectLabelSlice";
import { AppDispatch, RootState } from "../../store/store";
import { ImageGalleryProps, ImageAnnotation } from "../../types/interface";
import { startSpinner, stopSpinner } from "../../store/slice/UISlice";
import { selectProjectById } from "../../store/slice/ProjectSlice";
import {
  fetchImages,
  // fetchAnnotatedImages,
  // fetchUnAnnotatedImages,
  Image,
  clearAnnotationImages,
  updateLabelColor,
  fetchImageDetailsById,
  updateImageInList,
  fetchListOfAiModels,
} from "../../store/slice/ProjectImagesUploadedSlice";
import {
  saveImageAnnotation,
  fetchLabelDetails,
  updateAnnotation,
  deleteAnnotation,
  addAnnotationMagicWand,
  selectAllForColor,
  deleteAllAnnotations,
  updateLabelDetails,
  labelAssistedAnnotations,
  saveBulkImageAnnotation,
  fetchModelDetails,
} from "../../store/slice/projectAnnotationSlice";
import PushPinIcon from "@mui/icons-material/PushPin";
import Checkbox from "@mui/material/Checkbox";
import { fabric } from "fabric";
import MagicWand from "../../assets/img/magicwand.svg";
import ZoomIn from "../../assets/img/zoomin.svg";
import ZoomOut from "../../assets/img/zoomout.svg";
import Reset from "../../assets/img/reset.svg";
import TickMark from "../../assets/img/tickMark.png";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { LabelProperty } from "../../types/interface/Annotation.interface";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PhotoGalleryIcon from "../../assets/img/photosgallery.png";
import NavigateBeforeOutlinedIcon from "@mui/icons-material/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import {
  BackHandOutlined,
  HexagonOutlined,
  NavigationOutlined,
  RectangleOutlined,
} from "@mui/icons-material";
import { fetchProjectById } from "../../store/slice/projectHandler";
import { ProjectLabelItem } from "../../types/interface/ProjectLabel.interface";
import { v4 as uuidv4 } from "uuid";
import { colorSet } from "../../constants";

type Point = { x: number; y: number };

interface ScalingProperties {
  left: number;
  top: number;
  scaleX: number;
  scaleY: number;
}

export interface CustomFabricObject extends fabric.Object {
  label?: string;
  id?: string;
  points?: fabric.Point[];
  edit?: boolean;
  cornerStrokeWidth?: number;
}

interface CustomRect extends fabric.Rect {
  id?: string;
}

interface CustomPolygon extends fabric.Polygon {
  id?: string;
  edit?: boolean;
  cornerStrokeWidth?: number;
}

export interface ProjectLabels {
  value: string;
  label: string;
  color: string;
}

export interface Project {
  id: string;
  labels: number;
  images: number;
  annotations: number;
  models: number;
  imageUrl: string;
  thubmImageUrl: string;
  name: string;
  description: string;
  taskTypeId: string;
  domainTypeId: string;
  createdDate: string; // Consider changing this to Date if you parse it
  customerId: string;
  liked: boolean;
  isSample: boolean;
  colour: string;
  isImageUpload: boolean;
  isAnnotate: boolean;
  isvalidator: boolean;
  isTrainer: boolean;
  isProjectOwner: boolean;
}

export interface AnnotationData {
  annotationId: string;
  type: string;
  annotation: string[];
  lableId: string;
  projectLabel: string;
  labelColor: string;
  confidence: number;
}

const Annotate: React.FC<ImageGalleryProps> = ({ id, isProjectOwner }) => {
  const canvasElementRef = useRef<HTMLCanvasElement | null>(null);
  const modalCanvasElementRef = useRef<HTMLCanvasElement | null>(null);
  const canvasRef = useRef<fabric.Canvas | null>(null);
  const modalCanvasRef = useRef<fabric.Canvas | null>(null);
  const EditPolygonRef = useRef<(() => void) | null>(null);
  const handleRectangleToolRef = useRef<(() => void) | null>(null);
  const addPolygonRef = useRef<(() => void) | null>(null);
  const handleMagicWandToolRef = useRef<(() => void) | null>(null);
  const selectedImageRef = useRef<Image | null>(null);
  const toolRef = useRef("select");
  const originalImageRef = useRef<fabric.Image | null>(null);
  const imageSizeRef = useRef<HTMLImageElement | null>(null);
  const modalImageBoundsRef = useRef({ left: 0, top: 0, right: 0, bottom: 0 });

  const saveLabelDetailsRef = useRef<((arg: ProjectLabels) => void) | null>(
    null
  );
  const labelRef = useRef<HTMLSelectElement>(null);
  const allLabelRef = useRef<ProjectLabelItem[]>([]);
  const resetZoomRef = useRef<(() => void) | null>(null);
  const modalResetZoomRef = useRef<(() => void) | null>(null);
  const modalZoomInRef = useRef<(() => void) | null>(null);
  const modalZoomOutRef = useRef<(() => void) | null>(null);

  const selectedLabelColorRef = useRef<string>("");
  const drawerRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef<HTMLDivElement | null>(null);
  const [taskTypes, setTaskTypes] = useState(null);
  const [selectedImage, setSelectedImage] = useState<Image | null>(null);
  const [selectedTool, setSelectedTool] = useState("select");
  const [selectedLabel, setSelectedLabel] = useState<ProjectLabels>({
    value: "",
    label: "",
    color: "",
  });
  const [showDiv, setShowDiv] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [labelName, setLabelName] = useState<string>("");
  // const [objectTracking, setObjectTracking] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<string>("");
  const [zoomLevel, setZoomLevel] = useState<number>(1);
  const [previousActiveObjectId, setPreviousActiveObjectId] = useState<
    string | null
  >(null);
  const [selectedAnnotationId, setSelectedAnnotationId] = useState<
    string | null
  >(null);
  const [tmprectanglePoints, setTmpRectanglePoints] = useState<number[] | null>(
    null
  );
  const [polygonPoints, setPolygonPoints] = useState<Point[] | null>(null);
  const [projectAnnotationId, setProjectAnnotationId] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [deleteAnnotationModal, setDeleteAnnotationModal] =
    useState<boolean>(false);
  const [deleteAllAnnotationModal, setDeleteAllAnnotationModal] =
    useState<boolean>(false);
  const [isImagesLoaded, setIsImagesLoaded] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [currentOption, setCurrentOption] = useState<string | null>(null);
  const [deleteProjectLabelModal, setDeleteProjectLabelModal] =
    useState<boolean>(false);
  const [selectedProjectLabelIdForEdit, setSelectedProjectLabelIdForEdit] =
    useState<string | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>("all");
  const [projectDetails, setProjectDetails] = useState<Project>({
    id: "",
    labels: 0,
    images: 0,
    annotations: 0,
    models: 0,
    imageUrl: "",
    thubmImageUrl: "",
    name: "",
    description: "",
    taskTypeId: "",
    domainTypeId: "",
    createdDate: "",
    customerId: "",
    liked: false,
    isSample: false,
    colour: "",
    isImageUpload: false,
    isAnnotate: false,
    isvalidator: false,
    isTrainer: false,
    isProjectOwner: false,
  });
  const [totalImageCount, setTotalImageCount] = useState<number>(0);
  const [annotatedImgCount, setAnnotatedImgCount] = useState<number>(0);
  const [unAnnotatedImageCount, setUnAnnotatedImageCount] = useState<number>(0);
  const [isAnnoSaving, setIsAnnoSaving] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isToScroll, setIsToScroll] = useState(true);
  const [isGalleryShown, setIsGalleryShown] = useState(false);
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [isLabelAssistModelopen, setIsLabelAssistModelopen] = useState(false);
  const [confidenceValue, setConfidenceValue] = useState(10);
  const [isAnnotationsLoading, setIsAnnotationsLoading] = useState(false);
  const [labelAssistedImage, setLabelAssistedImage] = useState<
    AnnotationData[] | null
  >([]);
  const [AIAssistedLabels, setAIAssistedLabels] = useState<string[] | null>(
    null
  );
  const [selectedAILabels, setSelectedAILabels] = useState<string[] | null>([]);
  const [filteredlabelAssistedImage, setFilteredlabelAssistedImage] = useState<
    AnnotationData[] | null
  >([]);
  const [modelName, setModelName] = useState<string>("");
  const [isSaving, setIsSaving] = useState<boolean>(false);

  //  localStorage.setItem("showImageDrawer", false.toString());
  const PAGE_SIZE = 40;

  const dispatch = useDispatch<AppDispatch>();

  const { labels } = useSelector((state: RootState) => state.projectLabel);

  const { labelDetails } = useSelector(
    (state: RootState) => state.projectAnnotation
  );

  const {
    annotationImages,
    totalCount,
    annotatedImageCount,
    totalPages,
    isAdmin,
    listofAiModels,
  } = useSelector((state: RootState) => state.ProjectImagesUploaded);

  const project = useSelector((state: RootState) =>
    selectProjectById(state, id)
  );

  const { tasks } = useSelector((state: RootState) => state.Tasks);

  const showImageDrawer = (isGalleryShown: any) => {
    setIsGalleryShown(isGalleryShown);
    if (isGalleryShown) {
      localStorage.setItem("showImageDrawer", true.toString());
    } else {
      localStorage.setItem("showImageDrawer", false.toString());
    }
  };

  const loadImgPromise = async (url: string): Promise<HTMLImageElement> =>
    await new Promise((ok, fail) => {
      let img = document.createElement("img");
      img.onload = () => {
        ok(img);
      };
      img.onerror = fail;
      img.src = url;
    });

  const fetchData = async (page: number, count: number, annotation: string) => {
    try {
      await dispatch(fetchImages({ projectId: id, page, count, annotation }))
        .unwrap()
        .then(() => {
          setIsImagesLoaded(true);
        });
    } catch (error) {
      toast.error("Failed to fetch image list");
    } finally {
    }
  };

  useEffect(() => {
    const fetchLabels = async () => {
      const canvasState = {
        zoomLevel: 1,
        panOffsetX: 0,
        panOffsetY: 0,
      };

      localStorage.setItem("canvasState", JSON.stringify(canvasState));

      try {
        await dispatch(fetchProjectLabels(id))
          .unwrap()
          .then((response) => {
            if (response.length === 0) {
              toast.info("Add label to start annotating!");
            }
            allLabelRef.current = response;
          });
      } catch (error) {
        //toast.error("Failed to fetch label list");
      } finally {
      }
    };

    if (id) {
      const page = 1;
      const count = PAGE_SIZE;
      fetchData(page, count, "all");

      dispatch(fetchLabels);
    }
  }, [id]);

  // check the default label to be selected on page load
  useEffect(() => {
    const mappedProjectClass = labels.map((option) => ({
      value: option.id,
      label: option.name,
      color: option.labelColor,
    }));

    setSelectedLabel(mappedProjectClass[0]);
    const labelIndex = labels.length % colorSet.length;
    setSelectedColor(colorSet[labelIndex].value);
    if (mappedProjectClass[0]) {
      setSelectedValue(mappedProjectClass[0].value);
    }
  }, [labels]);

  useEffect(() => {
    if (selectedFilter === "all") {
      setTotalImageCount(totalCount);
      setAnnotatedImgCount(annotatedImageCount);
      if (totalCount !== 0) {
        setUnAnnotatedImageCount(totalCount - annotatedImageCount);
      }
    }
  }, [totalCount, annotatedImageCount, selectedFilter]);

  useEffect(() => {
    const setDefaultImage = () => {
      let selectedImageId;

      if (annotationImages.length > 0) {
        setIsImagesLoaded(true);
        if (!isImagesLoaded) {
          const imageId = localStorage.getItem("imageToAnnotateId");
          if (imageId !== "") {
            const selectedImageIndex = annotationImages.findIndex(
              (image) => image.id === imageId
            );

            if (selectedImageIndex !== -1) {
              selectedImageId = annotationImages[selectedImageIndex].id;

              setCurrentIndex(selectedImageIndex);
            } else {
              selectedImageId = annotationImages[0].id;
              setCurrentIndex(0);
            }
          } else {
            selectedImageId = annotationImages[0].id;
            setCurrentIndex(0);
          }
          loadImageDetails(selectedImageId);
        }
      } else {
        setIsImagesLoaded(false);
        dispatch(stopSpinner());
      }
    };

    setDefaultImage();
  }, [annotationImages]);

  const loadImageDetails = (imageId: string) => {
    dispatch(fetchImageDetailsById(imageId))
      .unwrap()
      .then((response) => {
        if (selectedTool === "rect") {
          if (handleRectangleToolRef.current) {
            handleRectangleToolRef.current();
          }
        } else if (selectedTool === "poly") {
          if (addPolygonRef.current) {
            addPolygonRef.current();
          }
        }

        setSelectedImage(response.imageUrlModel[0]);
        setIsImageChanged(true);

        if (!response.imageUrlModel[0].isAnnotator && !isProjectOwner) {
          setSelectedTool("");
          handleClick("select");
        }

        selectedImageRef.current = response.imageUrlModel[0];
      });
  };

  useEffect(() => {
    dispatch(startSpinner("Organizing Your Dataset"));
    if (isImagesLoaded) {
      if (!canvasElementRef.current) {
        dispatch(stopSpinner());
        return;
      }

      if (annotationImages.length === 0) {
        dispatch(stopSpinner());
        return;
      }

      // Initialize Fabric canvas
      canvasRef.current = new fabric.Canvas(canvasElementRef.current, {
        preserveObjectStacking: true,
        selection: false,
      });

      setupCanvasEvents();

      document.addEventListener("mousemove", trackMouse);

      // Cleanup on unmount
      return () => {
        canvasRef.current?.dispose();
        dispatch(clearAnnotationImages());
        dispatch(stopSpinner());
      };
    }
  }, [isImagesLoaded]);

  useEffect(() => {
    if (!selectedImage) {
      return;
    }

    if (annotationImages.length === 0) {
      return;
    }

    if (isImageChanged) {
      dispatch(startSpinner("Adding Image into Canvas"));
      let selectedImageUrl = selectedImage.imageUrl.toLowerCase();

      const backgroundImageUrl = selectedImage
        ? `${process.env.REACT_APP_SERVER_BASEURL}${selectedImageUrl}`
        : "";
      setImageUrl(backgroundImageUrl);

      fabric.Image.fromURL(
        backgroundImageUrl,
        (img: fabric.Image | null) => {
          if (!img || !canvasRef.current) return;

          if (img) {
            // Clear previous background image
            canvasRef.current.setBackgroundImage(
              "",
              canvasRef.current.renderAll.bind(canvasRef.current)
            );

            if (img.width) {
              canvasRef.current.setWidth(img.width || 0);
            }

            if (img.height) {
              canvasRef.current.setHeight(img.height || 0);
            }
          }

          // Set new background image
          canvasRef.current.setBackgroundImage(
            img,
            canvasRef.current.renderAll.bind(canvasRef.current),
            {
              opacity: 1,
            }
          );

          originalImageRef.current = img;
          restoreCanvasState();
          canvasRef.current.renderAll();

          if (imageUrl && imageUrl === backgroundImageUrl) {
            dispatch(stopSpinner());
          }
        },
        { crossOrigin: "anonymous" } // Use this if images are from a different origin
      );

      dispatch(updateLabelDetails(selectedImage));
      loadPreviousAnnotations();
    }
  }, [selectedImage, isImageChanged]);

  const setupCanvasEvents = () => {
    setTimeout(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      setSelectedTool(selectedTool);
      let origX = 0;
      let origY = 0;
      let isEditing = false;
      let isDrawing = false;
      let isPanning = false;
      let isDragging = false;
      let tool = selectedTool;
      let rect: fabric.Rect | null = null;

      // Polygon Variables
      let isCreatingPolygon = true;
      let tmpPolygonPoints: Point[] = [];
      let lineIndicatorFromFirst: fabric.Line | null = null;
      let lineIndicatorFromLast: fabric.Line | null = null;
      let line;
      let fillShape: fabric.Polygon;
      let polygonFillPoints;

      let previousPolygonModifiedPoints: Point[] = [];
      let isDrawingRectangle = false;
      let tmpRectangle: fabric.Rect | null = null;
      let selectedLabelColor: string;
      let lastPosX: number | null = null;
      let lastPosY: number | null = null;

      if (selectedLabel) {
        selectedLabelColor = selectedLabel.color;
      }

      if (canvas) {
        canvas.on("object:modified", async function (options) {
          toast.dismiss();
          dispatch(startSpinner("Saving annotation"));
          let modifiedObject = options.target as CustomFabricObject;
          if (selectedImageRef.current) {
            if (modifiedObject && modifiedObject.type === "polygon") {
              let cornerSize = calculateCornerSize();
              let initialStrokeWidth = await calculateStrokeWidth();
              calculateCircleRadius();
              let strokeWidth;
              if (initialStrokeWidth) {
                strokeWidth = initialStrokeWidth / canvas!.getZoom();
              }
              let newPoints: Point[] | null = null;
              let matrix = modifiedObject.calcTransformMatrix();
              let translatedPoints = (modifiedObject as fabric.Polygon)
                .get("points")!
                .map(function (p: fabric.Point) {
                  return {
                    x: p.x - (modifiedObject as fabric.Polygon).pathOffset.x,
                    y: p.y - (modifiedObject as fabric.Polygon).pathOffset.y,
                  };
                });

              for (var i = 0; i < translatedPoints.length; i++) {
                translatedPoints[i].x =
                  matrix[0] * translatedPoints[i].x +
                  matrix[2] * translatedPoints[i].y +
                  matrix[4];
                translatedPoints[i].y =
                  matrix[1] * translatedPoints[i].x +
                  matrix[3] * translatedPoints[i].y +
                  matrix[5];
              }

              let isOutOfBounds = false;

              translatedPoints.forEach(function (point) {
                if (canvas!.width && canvas!.height) {
                  if (
                    point.x < 0 ||
                    point.x > canvas!.width ||
                    point.y < 0 ||
                    point.y > canvas!.height
                  ) {
                    isOutOfBounds = true;
                  }
                }
              });

              if (isOutOfBounds) {
                //Ensure all points remain within canvas boundaries
                previousPolygonModifiedPoints.forEach(function (point) {
                  if (canvas!.width && canvas!.height) {
                    if (point.x < 0) {
                      point.x = 0;
                    } else if (point.x > canvas!.width) {
                      point.x = canvas!.width;
                    }

                    if (point.y < 0) {
                      point.y = 0;
                    } else if (point.y > canvas!.height) {
                      point.y = canvas!.height;
                    }
                  }
                });
                newPoints = previousPolygonModifiedPoints;
              } else {
                newPoints = translatedPoints;
                previousPolygonModifiedPoints = translatedPoints;
              }

              canvas!.remove(modifiedObject);
              const backgroundColor = modifiedObject.fill;

              let polygon = new fabric.Polygon(newPoints, {
                fill: backgroundColor,
                stroke: "black",
                strokeWidth: strokeWidth,
                objectCaching: false,
                transparentCorners: false,
                cornerColor: "yellow",
                strokeUniform: true,
                cornerSize: cornerSize,
                selectable: false,
                perPixelTargetFind: true,
              });

              (polygon as any).id = (modifiedObject as any).id
                ? (modifiedObject as any).id
                : "";

              polygon.setControlsVisibility({
                mtr: false,
              });
              canvas!.add(polygon);
              canvas!.setActiveObject(polygon);
              EditPolygon();
              canvas!.renderAll();

              const polygonPoints = await convertToPolygonStringArray(
                newPoints
              );

              if (!polygonPoints) {
                toast.error("Annotation Cordinates are Empty");
                dispatch(stopSpinner());
                return;
              }

              let editableIndex =
                selectedImageRef.current.annotations.findIndex(
                  (obj) => obj.annotationId === modifiedObject.id
                );

              if (editableIndex !== -1) {
                const annotationDetails =
                  selectedImageRef.current.annotations[editableIndex];

                const annotationSaveData = {
                  type: "Polygon",
                  annotation: polygonPoints,
                  annotationId: annotationDetails.annotationId,
                  projectLabelId: annotationDetails.lableId,
                  projectImageId: selectedImageRef.current.id,
                  projectId: id,
                };

                setPreviousActiveObjectId(annotationDetails.annotationId);

                await dispatch(updateAnnotation(annotationSaveData))
                  .unwrap()
                  .then((response) => {
                    setIsImageChanged(false);

                    const updated = { ...selectedImageRef.current! };

                    updated.annotations = updated.annotations.map((ann) =>
                      ann.annotationId === annotationSaveData.annotationId
                        ? {
                            ...ann,
                            type: annotationSaveData.type,
                            annotation: [annotationSaveData.annotation],
                          }
                        : ann
                    );

                    selectedImageRef.current = updated;

                    dispatch(
                      updateImageInList({
                        id: updated.id,
                        updatedImage: updated,
                      })
                    );

                    setSelectedImage(selectedImageRef.current);
                  });
              }
            } else if (modifiedObject && modifiedObject.type === "rect") {
              checkBoundaries(modifiedObject);

              const left = modifiedObject.left ?? 0;
              const top = modifiedObject.top ?? 0;
              const width = modifiedObject?.width! * modifiedObject.scaleX!;
              const height = modifiedObject?.height! * modifiedObject.scaleY!;

              let cordinates = [left, top, width, height];

              // Count the number of zeros
              const zeroCount = cordinates.filter(
                (value) => value === 0
              ).length;
              const negativeCount = cordinates.filter(
                (value) => value < 0
              ).length;

              // Check if there are exactly two zeros
              if (zeroCount === 2 || negativeCount > 0) {
                toast.error("Can't save Annotation");
                const activeObject = canvas!.getActiveObject();
                if (activeObject) {
                  canvas!.remove(activeObject);

                  let initialStrokeWidth = await calculateStrokeWidth();
                  let strokeWidth = 0;

                  if (initialStrokeWidth && canvasRef.current) {
                    strokeWidth =
                      initialStrokeWidth / canvasRef.current.getZoom();
                  }

                  let cornerSize = calculateCornerSize();

                  selectedImageRef.current.annotations.forEach((annotation) => {
                    if (
                      annotation.type === "Rectangle" &&
                      annotation.annotationId === modifiedObject.id
                    ) {
                      const [left, top, width, height] =
                        annotation.annotation[0].split(",").map(parseFloat);

                      const leftValue =
                        left * imageSizeRef.current!.naturalWidth;
                      const topValue =
                        top * imageSizeRef.current!.naturalHeight;
                      const widthValue =
                        width * imageSizeRef.current!.naturalWidth;
                      const heightValue =
                        height * imageSizeRef.current!.naturalHeight;

                      const fillColor = lightenColor(annotation.labelColor, 0);

                      // Create Fabric.js rectangle
                      const rect = new fabric.Rect({
                        left: leftValue,
                        top: topValue,
                        width: widthValue,
                        height: heightValue,
                        fill: fillColor,
                        stroke: "black",
                        padding: -(strokeWidth * 1.5),
                        strokeWidth: strokeWidth,
                        objectCaching: false,
                        strokeUniform: true,
                        cornerSize: cornerSize,
                        selectable: false,
                        hasBorders: false,
                      }) as CustomRect;

                      rect.id = annotation.annotationId;

                      fabric.Object.prototype.transparentCorners = false;
                      fabric.Object.prototype.cornerColor = "white";
                      fabric.Object.prototype.cornerStyle = "circle";
                      fabric.Object.prototype.cornerStrokeColor = "black";
                      (fabric.Object.prototype as any).cornerStrokeWidth = "3";
                      fabric.Rect.prototype._controlsVisibility = {
                        mtr: false,
                      };

                      if (canvasRef.current) {
                        canvasRef.current.add(rect);
                      }

                      if (canvasRef.current) {
                        canvasRef.current.setActiveObject(rect);
                      }
                    }
                  });
                }
                dispatch(stopSpinner());
                return;
              }

              let modifiedRect: number[] = [left, top, width, height];

              const rectanglePoints = await convertToRectStringArray(
                modifiedRect
              );

              if (!rectanglePoints) {
                toast.error("Annotation Cordinates are Empty");
                dispatch(stopSpinner());
                return;
              }

              let editableIndex =
                selectedImageRef.current.annotations.findIndex(
                  (obj) => obj.annotationId === modifiedObject.id
                );

              if (editableIndex !== -1) {
                const annotationDetails =
                  selectedImageRef.current.annotations[editableIndex];

                const annotationSaveData = {
                  type: "Rectangle",
                  annotation: rectanglePoints,
                  annotationId: annotationDetails.annotationId,
                  projectLabelId: annotationDetails.lableId,
                  projectImageId: selectedImageRef.current.id,
                  projectId: id,
                };

                setPreviousActiveObjectId(annotationDetails.annotationId);
                try {
                  await dispatch(updateAnnotation(annotationSaveData))
                    .unwrap()
                    .then((response) => {
                      setIsImageChanged(false);

                      const updated = { ...selectedImageRef.current! };

                      updated.annotations = updated.annotations.map((ann) =>
                        ann.annotationId === annotationSaveData.annotationId
                          ? {
                              ...ann,
                              type: annotationSaveData.type,
                              annotation: [annotationSaveData.annotation],
                            }
                          : ann
                      );

                      selectedImageRef.current = updated;

                      dispatch(
                        updateImageInList({
                          id: updated.id,
                          updatedImage: updated,
                        })
                      );

                      setSelectedImage(selectedImageRef.current);
                    });
                } catch (e) {
                  toast.error("Failed to Save Annotation");
                }
              }
            }
          }
          dispatch(stopSpinner());
        });

        canvas.on("object:moving", async function (options) {
          const modifiedObject = options.target;

          if (modifiedObject && modifiedObject.type === "rect") {
            checkBoundaries(modifiedObject);
          }

          if (modifiedObject) {
            if (modifiedObject.left !== undefined && modifiedObject.left <= 0) {
              modifiedObject.left = 1; // Update the object's left property directly
              return false;
            }

            if (modifiedObject.top !== undefined && modifiedObject.top <= 0) {
              modifiedObject.top = 1; // Update the object's left property directly
              return false;
            }
          }
        });

        // Add event listener for object:scaling to keep track of last positions of points

        canvas.on(
          "object:scaling",
          function (event: fabric.IEvent<MouseEvent>) {
            let scaledObject = event.target as fabric.Object & {
              lastPositions?: Array<{ x: number; y: number }>;
              points?: Array<{ x: number; y: number }>;
            };

            if (scaledObject) {
              // Check if the scaled object is a polygon
              if (scaledObject.type === "polygon") {
                // Initialize an array to store last positions of points if not already initialized
                if (!scaledObject.lastPositions && scaledObject.points) {
                  scaledObject.lastPositions = scaledObject.points.map(
                    (point) => ({
                      x: point.x,
                      y: point.y,
                    })
                  );
                }

                // Update last positions of points based on current scaling
                if (scaledObject.points && scaledObject.lastPositions) {
                  scaledObject.points.forEach((point, index) => {
                    const lastPosition = scaledObject.lastPositions![index];
                    scaledObject.lastPositions![index] = {
                      x: lastPosition.x * scaledObject.scaleX!,
                      y: lastPosition.y * scaledObject.scaleY!,
                    };
                  });
                }
              } else if (scaledObject.type === "rect") {
                scaling(event);
              }
            }
          }
        );

        canvas.on("mouse:down", async function (options) {
          if (isPanning) {
            isDragging = true;
            lastPosX = options.e.clientX;
            lastPosY = options.e.clientY;
          }

          if (toolRef.current === "select") {
            let pointer = canvas!.getPointer(options.e);
            let target: CustomFabricObject | null =
              getTopObjectUnderPointer(pointer);
            if (target) {
              selectAnnotationFromCanvas(target);
            }

            if (target && target.id) {
              setSelectedAnnotationId(target.id);
            }
            if (target) {
              if (target.type === "polygon") {
                previousPolygonModifiedPoints = target.points ?? [];
              }
            }
          }

          let activeObject = canvas!.getActiveObject();

          if (toolRef.current === "poly") {
            isDrawing = false;

            let pointer = canvas!.getPointer(options.e);

            let cornerSize = calculateCornerSize() / (canvas!.getZoom() * 1.5);
            let initialStrokeWidth = await calculateStrokeWidth();

            calculateCircleRadius();
            let strokeWidth = 0;
            if (initialStrokeWidth) {
              strokeWidth = initialStrokeWidth / canvas!.getZoom();
            }

            if (
              options.target &&
              options.target.type === "circle" &&
              isCreatingPolygon
            ) {
              if (tmpPolygonPoints.length > 2) {
                drawPolygon(tmpPolygonPoints);
                canvas!.selection = true;
                tmpPolygonPoints = [];
              }
            } else if (isCreatingPolygon) {
              if (!activeObject) {
                // if (activeObject.type === "polygon") {
                let circle = new fabric.Circle({
                  radius: cornerSize,
                  fill: "white",
                  stroke: "black",
                  strokeWidth: strokeWidth,
                  left: pointer.x,
                  top: pointer.y,
                  selectable: false,
                  hasControls: false,
                  hasBorders: false,
                  originX: "center",
                  originY: "center",
                  strokeUniform: true,
                  cornerSize: cornerSize,
                });

                if (tmpPolygonPoints.length > 0) {
                  let prevPoint = tmpPolygonPoints[tmpPolygonPoints.length - 1];
                  line = new fabric.Line(
                    [prevPoint.x, prevPoint.y, pointer.x, pointer.y],
                    {
                      stroke: "black",
                      strokeWidth: strokeWidth,
                      selectable: false,
                      evented: false,
                    }
                  );
                  canvas!.add(line);
                }

                tmpPolygonPoints.push({ x: pointer.x, y: pointer.y });
                canvas!.add(circle);

                // Create fill shape using the polygonPoints array
                if (tmpPolygonPoints.length > 1) {
                  if (fillShape) {
                    canvas!.remove(fillShape);
                  }

                  const fillColor = lightenColor(
                    selectedLabelColorRef.current,
                    0
                  );

                  fillShape = new fabric.Polygon(tmpPolygonPoints, {
                    fill: fillColor ? fillColor : "red", // Fill color
                    opacity: 0.2, // Opacity
                    selectable: false,
                    evented: false,
                  });
                  canvas!.add(fillShape);
                }
                // }
              }
            }
          }

          if (toolRef.current === "rect") {
            isDrawing = true;
            isPanning = false;
          }

          if (activeObject) {
            isDrawing = false;
          } else {
            removeLastObject();
            setSelectedAnnotationId(null);
            setPreviousActiveObjectId(null);
          }

          if (isDrawing) {
            if (toolRef.current === "rect") {
              var pointer = canvas!.getPointer(options.e);
              if (!isDrawingRectangle) {
                origX = pointer.x;
                origY = pointer.y;
                isDrawingRectangle = true;
              } else {
                isDrawingRectangle = false;
                if (pointer.x > canvas!.width!) {
                  pointer.x = canvas!.width || 0;
                } else if (pointer.x < 0) {
                  pointer.x = 0;
                }
                if (pointer.y > canvas!.height!) {
                  pointer.y = canvas!.height || 0;
                } else if (pointer.y < 0) {
                  pointer.y = 0;
                }

                // Remove the temporary rectangle
                if (tmpRectangle) {
                  canvas!.remove(tmpRectangle);
                  tmpRectangle = null;
                }
                createRectangle(pointer);
                //}
              }
            }
          }

          if (!activeObject && isEditing) {
            setSelectedAnnotationId(null);
          }

          if (toolRef.current === "magicWand") {
            canvas!.selectionColor = "transparent";
            canvas!.selectionBorderColor = "transparent";
            canvas!.selectionLineWidth = 0;
          }
        });

        canvas.on("mouse:up", async function (event) {
          if (toolRef.current === "magicWand") {
            try {
              isPanning = false;
              let pointer = canvas?.getPointer(event.e);
              let clickedPoint = [pointer?.x ?? 0, pointer?.y ?? 0, 1];
              const points = getAnnotationPointsWithoutDecimals(clickedPoint);

              const data = {
                id: uuidv4(),
                points: points,
                projectImageId: selectedImageRef.current!.id,
                projectId: id,
              };

              dispatch(startSpinner("Saving Annotation..."));

              const response = await dispatch(addAnnotationMagicWand(data));
              if (response) {
                let cornerSize = calculateCornerSize();
                let strokeWidth = await calculateStrokeWidth();

                const magicWandDataAPI = response.payload.contours;

                const dataArray = magicWandDataAPI
                  .toString()
                  .split(",")
                  .map(Number);

                const coordinates = [];
                for (let i = 0; i < dataArray.length; i += 2) {
                  coordinates.push({
                    x: dataArray[i],
                    y: dataArray[i + 1],
                  });
                }

                const fillColor = lightenColor(
                  selectedLabelColorRef.current,
                  0
                );

                var magicWandPolygon = new fabric.Polygon(coordinates, {
                  fill: fillColor ? fillColor : "#c7c5c54f",
                  stroke: "black",
                  strokeWidth: strokeWidth,
                  objectCaching: false,
                  transparentCorners: false,
                  cornerColor: "yellow",
                  strokeUniform: true,
                  cornerSize: cornerSize,
                  selectable: false,
                  perPixelTargetFind: true,
                }) as CustomPolygon;

                magicWandPolygon.id = "";

                canvas!.add(magicWandPolygon);
                canvas!.setActiveObject(magicWandPolygon);
                canvas!.renderAll();
                EditPolygon();
                setPolygonPoints(coordinates);
                previousPolygonModifiedPoints = coordinates;
                isDrawing = false;
                dispatch(stopSpinner());
              }

              setSelectedAnnotationId(null);
            } catch (e) {
              dispatch(stopSpinner());
              toast.error("can't save Magic Wand Annotation");
            }
          }

          isDragging = false;

          isDrawing = true;
          event.e.preventDefault();
          event.e.stopPropagation();
        });

        canvas.on("mouse:move", async function (options) {
          if (isDragging) {
            if (isPanning === true && options && options.e) {
              let e = options.e;
              let deltaX = e.clientX - lastPosX!;
              let deltaY = e.clientY - lastPosY!;

              lastPosX = e.clientX;
              lastPosY = e.clientY;

              saveCanvasState();

              // Check if panning is in progress
              if (canvas) {
                const activeImage = canvas.backgroundImage as fabric.Image; // or whatever your image object is
                const imageWidth = activeImage?.width ?? canvas.width!;
                const imageHeight = activeImage?.height ?? canvas.height!;

                const avgImageSize = (imageWidth + imageHeight) / 2;

                // Adjust pan speed based on image size
                let panSpeedMultiplier = 1;
                if (avgImageSize > 5000) {
                  panSpeedMultiplier = 10;
                } else if (avgImageSize > 4000) {
                  panSpeedMultiplier = 7;
                } else if (avgImageSize > 3000) {
                  panSpeedMultiplier = 6;
                } else if (avgImageSize > 2000) {
                  panSpeedMultiplier = 5;
                } else if (avgImageSize > 1000) {
                  panSpeedMultiplier = 3;
                } else {
                  panSpeedMultiplier = 1;
                }

                let viewportTransform = canvas!.viewportTransform!.slice();
                var newLeft = viewportTransform[4] + deltaX;
                var newTop = viewportTransform[5] + deltaY;

                if (
                  newLeft <= 0 &&
                  newTop <= 0 &&
                  newLeft + canvas?.width! * canvas.getZoom() >=
                    canvas.width! &&
                  newTop + canvas?.height! * canvas.getZoom() >= canvas.height!
                ) {
                  canvas.relativePan(
                    new fabric.Point(
                      deltaX * panSpeedMultiplier,
                      deltaY * panSpeedMultiplier
                    )
                  );
                }
              }
            }
          }

          if (tool === "poly") {
            let pointer = canvas!.getPointer(options.e);

            let initialStrokeWidth = await calculateStrokeWidth();

            let strokeWidth = initialStrokeWidth! / canvas!.getZoom();

            // Check if polygon creation is in progress
            if (isCreatingPolygon) {
              // Remove existing dotted lines
              if (lineIndicatorFromFirst!) {
                canvas!.remove(lineIndicatorFromFirst);
              }
              if (lineIndicatorFromLast!) {
                canvas!.remove(lineIndicatorFromLast);
              }
              if (fillShape) {
                canvas!.remove(fillShape);
              }

              // Create dotted lines from the first and last points to the current mouse position
              if (tmpPolygonPoints.length > 0) {
                // Dotted line from the first point to the current mouse position
                lineIndicatorFromFirst = new fabric.Line(
                  [
                    tmpPolygonPoints[0].x,
                    tmpPolygonPoints[0].y,
                    pointer.x,
                    pointer.y,
                  ],
                  {
                    strokeDashArray: [5, 5],
                    stroke: "black",
                    strokeWidth: strokeWidth,
                    selectable: false,
                    evented: false,
                  }
                );
                canvas!.add(lineIndicatorFromFirst);

                // Dotted line from the last point to the current mouse position
                lineIndicatorFromLast = new fabric.Line(
                  [
                    tmpPolygonPoints[tmpPolygonPoints.length - 1].x,
                    tmpPolygonPoints[tmpPolygonPoints.length - 1].y,
                    pointer.x,
                    pointer.y,
                  ],
                  {
                    strokeDashArray: [5, 5],
                    stroke: "black",
                    strokeWidth: strokeWidth,
                    selectable: false,
                    evented: false,
                  }
                );
                canvas!.add(lineIndicatorFromLast);
                polygonFillPoints = [];
                tmpPolygonPoints.forEach(function (point) {
                  polygonFillPoints.push({ x: point.x, y: point.y });
                });
                polygonFillPoints.push({ x: pointer.x, y: pointer.y });

                const fillColor = lightenColor(
                  selectedLabelColorRef.current,
                  0
                );

                fillShape = new fabric.Polygon(polygonFillPoints, {
                  //fill: "yellow",
                  fill: fillColor ? fillColor : "yellow",
                  opacity: 0.2,
                  selectable: false,
                  evented: false,
                });
                canvas!.add(fillShape);

                adjustObjectSizes();
                calculateCornerSize();
                calculateCircleRadius();
                canvas!.renderAll();
              }
            }
          }

          if (tool === "rect") {
            var pointer = canvas!.getPointer(options.e);

            // Calculate the rectangle's width and height based on the current mouse position
            let width = Math.abs(pointer.x - origX);
            let height = Math.abs(pointer.y - origY);
            let left = origX < pointer.x ? origX : pointer.x;
            let top = origY < pointer.y ? origY : pointer.y;

            let initialStrokeWidth = await calculateStrokeWidth();
            var strokeWidth = initialStrokeWidth! / canvas!.getZoom();

            // Create a temporary rectangle if it doesn't exist
            if (!tmpRectangle) {
              if (isDrawingRectangle) {
                const fillColor = lightenColor(
                  selectedLabelColorRef.current,
                  0
                );

                tmpRectangle = new fabric.Rect({
                  left: left,
                  top: top,
                  width: width,
                  height: height,
                  fill: fillColor ? fillColor : "#90A8CE",
                  opacity: 0.3,
                  stroke: "black",
                  strokeWidth: strokeWidth,
                  selectable: false, // make it non-selectable
                  evented: false, // disable events on the temp rectangle
                  padding: -(strokeWidth * 1.5),
                });

                canvas!.add(tmpRectangle);
              }
            } else {
              // Update the temporary rectangle's position and size
              tmpRectangle.set({
                left: left,
                top: top,
                width: width,
                height: height,
              });
            }
            canvas!.renderAll();
          }
        });

        canvas.on("mouse:wheel", function (opt: fabric.IEvent<WheelEvent>) {
          var delta = opt.e.deltaY;

          opt.e.preventDefault();
          opt.e.stopPropagation();

          var zoom = canvas!.getZoom();

          zoom *= 0.999 ** delta;

          if (zoom > 5) zoom = 5;
          if (zoom < 1) {
            zoom = 1;
            resetZoom();
          }

          const pointerCoords = canvas?.getPointer(opt.e);
          const pointer = new fabric.Point(pointerCoords!.x, pointerCoords!.y);

          zoom = Math.min(zoom);
          setZoomLevel(zoom);
          applyZoom(pointer, zoom);
        });
      }

      //#region Edit Polygon
      const EditPolygon = async (): Promise<void> => {
        const activeObject =
          canvasRef.current!.getActiveObject() as CustomFabricObject;

        if (!activeObject || activeObject.type !== "polygon") {
          console.log("No polygon selected or active.");
          return;
        }

        // Save the current points for later use
        previousPolygonModifiedPoints = [
          ...(activeObject.points || []),
        ] as fabric.Point[];

        // Toggle the editing mode
        activeObject.edit = !activeObject.edit;

        // Calculate corner size and stroke width
        const cornerSize = calculateCornerSize();
        const strokeWidth = 0.005 * imageSizeRef.current!.naturalWidth;
        if (activeObject.edit) {
          activeObject.cornerStyle = "circle";
          activeObject.cornerColor = "white";
          activeObject.cornerSize = cornerSize;
          activeObject.cornerStrokeColor = "black";
          activeObject.cornerStrokeWidth = strokeWidth;

          // Create custom controls for each point
          activeObject.controls = activeObject.points!.reduce(
            (acc: { [key: string]: fabric.Control }, point, index) => {
              const control = new fabric.Control({
                positionHandler: () =>
                  polygonPositionHandler(activeObject as fabric.Polygon, index),
                actionHandler: (eventData, transform, x, y) => {
                  const polygon = transform.target as fabric.Polygon;
                  polygon.points![index].x = x;
                  polygon.points![index].y = y;
                  canvas!.requestRenderAll();
                  return true;
                },
                actionName: "modifyPolygon",
              });

              // Assign the pointIndex for the control
              (control as any).pointIndex = index;

              acc[`p${index}`] = control;
              return acc;
            },
            {}
          );

          activeObject.hasBorders = !activeObject.edit;
          canvas!.requestRenderAll();
        } else {
          console.log("No polygon selected or active.");
        }
      };
      //#endregion

      EditPolygonRef.current = EditPolygon;

      let scalingProperties: ScalingProperties = {
        left: 0,
        top: 0,
        scaleX: 0,
        scaleY: 0,
      };

      function scaling(e: fabric.IEvent<MouseEvent>) {
        let shape = e.target as fabric.Object | undefined;
        if (shape && shape.canvas) {
          let maxWidth = shape.canvas?.width;
          let maxHeight = shape.canvas?.height;

          if (
            typeof shape.left === "undefined" ||
            typeof shape.top === "undefined" ||
            typeof shape.scaleX === "undefined" ||
            typeof shape.scaleY === "undefined"
          ) {
            return;
          }

          //left border
          if (shape.left! < 0) {
            shape.left = scalingProperties.left;
            shape.scaleX = scalingProperties.scaleX;
          } else {
            scalingProperties.left = shape.left;
            scalingProperties.scaleX = shape.scaleX;
          }

          //right border
          if (
            scalingProperties.scaleX * shape?.width! + shape.left! >=
            maxWidth!
          ) {
            shape.scaleX = (maxWidth! - scalingProperties.left) / shape?.width!;
          } else {
            scalingProperties.scaleX = shape.scaleX;
          }

          //top border
          if (shape.top! < 0) {
            shape.top = scalingProperties.top;
            shape.scaleY = scalingProperties.scaleY;
          } else {
            scalingProperties.top = shape.top;
            scalingProperties.scaleY = shape.scaleY;
          }

          //bottom border
          if (
            scalingProperties.scaleY * shape.height! + shape.top! >=
            maxHeight!
          ) {
            shape.scaleY = (maxHeight! - scalingProperties.top) / shape.height!;
          } else {
            scalingProperties.scaleY = shape.scaleY;
          }
        }
      }

      //#region Drawing Polygon
      async function drawPolygon(polyPoints: Point[]) {
        let cornerSize = calculateCornerSize();

        let initialStrokeWidth = await calculateStrokeWidth();

        calculateCircleRadius();
        let strokeWidth = initialStrokeWidth! / canvas!.getZoom();

        const fillColor = lightenColor(selectedLabelColorRef.current, 0);

        tool = "poly";
        isEditing = false;
        var polygon = new fabric.Polygon(polyPoints, {
          fill: fillColor ? fillColor : "#c7c5c54f",
          stroke: "black",
          strokeWidth: strokeWidth,
          objectCaching: false,
          transparentCorners: false,
          cornerColor: "yellow",
          strokeUniform: true,
          cornerSize: cornerSize,
          selectable: false,
          perPixelTargetFind: true,
        });

        //polygonObject = polygon

        // Remove the previous circles used to create the polygon
        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "circle") {
            canvas!.remove(obj);
          }
        });

        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "polygon" && obj.stroke === "transparent") {
            canvas!.remove(obj);
          }
        });

        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "line") {
            canvas!.remove(obj);
          }
        });

        previousPolygonModifiedPoints = polyPoints;
        canvas!.add(polygon);
        canvas!.renderAll();
        canvas!.setActiveObject(polygon);
        EditPolygon();
        setSelectedAnnotationId(null);
        setPolygonPoints(polyPoints);
        isPanning = false;
      }
      //#endregion

      //#region Add Rectangle
      async function addRectangle(
        x: number,
        y: number,
        x1: number,
        y1: number,
        fill: string
      ) {
        let cornerSize = calculateCornerSize();
        let initialStrokeWidth = await calculateStrokeWidth();
        let strokeWidth = 0;
        if (initialStrokeWidth) {
          strokeWidth = initialStrokeWidth / canvas!.getZoom();
        }

        let left = Math.min(x, x1);
        let top = Math.min(y, y1);

        // Calculate width and height
        let width = Math.abs(x1 - x);
        let height = Math.abs(y1 - y);

        var tmpRect = new fabric.Rect({
          left: left,
          top: top,
          width: width,
          height: height,
          fill: fill,
          stroke: "black",
          strokeWidth: strokeWidth,
          objectCaching: false,
          strokeUniform: true,
          cornerSize: cornerSize,
          selectable: false,
          padding: -(strokeWidth * 1.5),
        });

        tmpRect.toObject = (function (toObject) {
          return function (this: CustomFabricObject) {
            return fabric.util.object.extend(toObject.call(this), {
              label: this.label,
            });
          };
        })(tmpRect.toObject);

        for (let object of canvas!.getObjects()) {
          object.set("strokeWidth", strokeWidth);
        }

        canvas!.add(tmpRect);
        isDrawing = true;
        const rectArray = [left, top, width, height];
        setTmpRectanglePoints(rectArray);
        return tmpRect;
      }
      //#endregion

      //#region Create Rectangle
      async function createRectangle(pointer: Point) {
        if (isDrawing) {
          var rectWidth = pointer.x - origX;
          var rectHeight = pointer.y - origY;
          let rectLeft = origX;
          let rectTop = origY;

          // Check if all x, y points are equal
          if (
            rectWidth !== 0 ||
            rectHeight !== 0 ||
            rectLeft <= 0 ||
            rectTop <= 0
          ) {
            var rectangle = await addRectangle(
              origX,
              origY,
              pointer.x,
              pointer.y,
              "#c7c5c54f"
            );
            rect = rectangle;

            fabric.Object.prototype.transparentCorners = false;
            fabric.Object.prototype.cornerColor = "white";
            fabric.Object.prototype.cornerStyle = "circle";
            fabric.Object.prototype.cornerStrokeColor = "black";
            (fabric.Object.prototype as any).cornerStrokeWidth = "3";
            fabric.Rect.prototype._controlsVisibility = {
              mtr: false,
            };
            fabric.Object.prototype.hasBorders = false;
            canvas!.setActiveObject(rect);
            canvas!.renderAll();

            isDrawing = true;
            isEditing = false;
          }
        }
      }
      //#endregion

      //#region Reset Image after ZoomOut
      const resetZoom = async () => {
        isPanning = false;
        isDragging = false;

        if (originalImageRef.current) {
          let canvasWidth = canvas!.width;
          let canvasHeight = canvas!.height;
          let imgWidth =
            originalImageRef.current?.width! * originalImageRef.current.scaleX!;
          let imgHeight =
            originalImageRef.current.height! * originalImageRef.current.scaleY!;
          let bgLeft = (canvasWidth! - imgWidth) / 2;
          let bgTop = (canvasHeight! - imgHeight) / 2;
          // Adjust background image position based on panning
          bgLeft -= canvas!.viewportTransform![1];
          bgTop -= canvas!.viewportTransform![1];
          originalImageRef.current.set({
            left: bgLeft,
            top: bgTop,
          });

          if (toolRef.current === "pan") {
            tool = "select";
            setSelectedTool("select");
            canvas!.defaultCursor = "default";
          }

          setZoomLevel(1);
          canvas!.setViewportTransform([1, 0, 0, 1, 0, 0]); // Reset viewport transform
          adjustObjectSizes();
          // calculateCornerSize()
          calculateCircleRadius();

          let initialStrokeWidth = await calculateStrokeWidth();
          let strokeWidth;
          if (initialStrokeWidth) {
            strokeWidth = initialStrokeWidth / canvas!.getZoom();
          }
          for (let object of canvas!.getObjects()) {
            object.set("strokeWidth", strokeWidth);
          }
          saveCanvasState();
          canvas!.requestRenderAll();
        }
      };
      //#endregion

      resetZoomRef.current = resetZoom;

      //#region Handle Rectangle Tool
      const handleRectangleTool = () => {
        setTmpRectanglePoints(null);
        tool = "rect";
        canvas!.selection = false;
        canvas!.defaultCursor = "crosshair";
        isDrawing = true;
        canvas!.discardActiveObject();
        removeLastObject();
        removePolygon();
        canvas!.renderAll();
        if (tmpRectangle) {
          canvas!.remove(tmpRectangle);
          tmpRectangle = null;
        }
        origX = 0;
        origY = 0;
        isDrawingRectangle = false;
      };
      //#endregion

      handleRectangleToolRef.current = handleRectangleTool;

      //#region Handle Magic Wand Tool
      const handleMagicWandTool = () => {
        tool = "magicWand";
        canvas!.defaultCursor = "crosshair";
        isDrawing = true;
        canvas!.discardActiveObject();
        removePolygon();
        removeLastObject();
        isDrawingRectangle = false;
        origX = 0;
        origY = 0;
        canvas!.renderAll();
        if (tmpRectangle) {
          canvas!.remove(tmpRectangle);
          tmpRectangle = null;
        }
      };
      //#endregion

      handleMagicWandToolRef.current = handleMagicWandTool;

      //#region remove half created polygon
      const removePolygon = () => {
        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "circle") {
            canvas!.remove(obj);
          }
        });

        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "polygon" && obj.stroke === "transparent") {
            canvas!.remove(obj);
          }
        });

        canvas!.getObjects().forEach((obj) => {
          if (obj.type === "line") {
            canvas!.remove(obj);
          }
        });
        lineIndicatorFromFirst = null;
        lineIndicatorFromLast = null;
        tmpPolygonPoints = [];

        // Render the canvas to reflect changes
        canvas!.renderAll();
      };
      //#endregion

      //#region Add Polygon
      async function addPolygon() {
        tool = "poly";
        canvasRef.current!.selection = false;
        canvasRef.current!.defaultCursor = "crosshair";
        isDrawing = false;
        isPanning = false;
        isCreatingPolygon = true;
        isDrawingRectangle = false;
        origX = 0;
        origY = 0;
        tmpPolygonPoints = [];

        let activeObject =
          canvasRef.current!.getActiveObject() as CustomFabricObject;
        if (activeObject) {
          canvasRef.current!.discardActiveObject();
          if (!activeObject.id) {
            canvasRef.current!.remove(activeObject);
          }
        }

        //setShowAnnotationEditor(false)
        canvasRef.current!.renderAll();
        removeLastObject();
        removePolygon();
        if (tmpRectangle) {
          canvasRef.current!.remove(tmpRectangle);
          tmpRectangle = null;
        }
      }
      //#endregion

      addPolygonRef.current = addPolygon;

      //#region Panning
      const enablePanning = () => {
        if (canvasRef.current!.getActiveObject()) {
          canvasRef.current!.discardActiveObject();
        }

        isPanning = true;
        isDrawing = false;
        tool = "pan";
        canvasRef.current!.selection = false;
        canvasRef.current!.defaultCursor = "grabbing";
        removeLastObject();
        removePolygon();
      };
      //#endregion

      //#region Handle Select Tool
      const handleSelectTool = () => {
        tool = "select";
        isDrawing = false;
        isDragging = false;
        isPanning = false;
        canvasRef.current!.selection = false;
        canvasRef.current!.defaultCursor = "default";
        removeLastObject();
        removePolygon();
        canvasRef.current!.discardActiveObject();
        canvasRef.current!.renderAll();
      };
      //#endregion

      //#region Handle Key Down
      const handleEscapeKeyDown = (event: KeyboardEvent) => {
        if (event.keyCode === 27) {
          if (tool === "poly" || tool === "magicWand") {
            const activeObject =
              canvasRef.current!.getActiveObject() as CustomFabricObject;
            if (activeObject) {
              if (!activeObject.id) {
                canvasRef.current!.remove(activeObject);
              }
            }
          }

          //setShowAnnotationEditor(false)
          removeLastObject();
          removePolygon();
          if (tool === "rect") {
            origX = 0;
            origY = 0;
            isDrawingRectangle = false;
            if (tmpRectangle) {
              canvasRef.current!.remove(tmpRectangle);
            }
            tmpRectangle = null;
          }
        }

        if (event.shiftKey && (event.key === "R" || event.key === "r")) {
          handleRectangleTool();
          setSelectedTool("rect");
        } else if (event.shiftKey && (event.key === "A" || event.key === "a")) {
          setSelectedTool("select");
          handleSelectTool();
        } else if (event.shiftKey && (event.key === "P" || event.key === "p")) {
          setSelectedTool("poly");
          addPolygon();
        } else if (event.shiftKey && (event.key === "D" || event.key === "d")) {
          const zoomedInLevel = canvas!.getZoom();
          if (zoomedInLevel > 1) {
            setSelectedTool("pan");
            enablePanning();
          }
        } else if (event.shiftKey && (event.key === "M" || event.key === "m")) {
          handleMagicWandTool();
          setSelectedTool("magicWand");
        } else if (event.shiftKey && event.key === "+") {
          zoomIn();
        } else if (event.shiftKey && event.key === "_") {
          zoomOut();
        } else if (event.shiftKey && (event.key === "X" || event.key === "x")) {
          resetZoom();
        }
      };
      //#endregion

      window.addEventListener("keydown", handleEscapeKeyDown);

      const polygon = document.getElementById("addPolygon");
      if (polygon) {
        polygon.addEventListener("click", addPolygon);
      }

      const magicWand = document.getElementById("magicWand");
      if (magicWand) {
        magicWand.addEventListener("click", handleMagicWandTool);
      }

      const ZoomIn = document.getElementById("zoomIn");
      if (ZoomIn) {
        ZoomIn.addEventListener("click", zoomIn);
      }

      const ZoomOut = document.getElementById("zoomOut");
      if (ZoomOut) {
        ZoomOut.addEventListener("click", zoomOut);
      }

      const pan = document.getElementById("pan");
      if (pan) {
        pan.addEventListener("click", enablePanning);
      }

      const select = document.getElementById("select");
      if (select) {
        select.addEventListener("click", handleSelectTool);
      }

      const reset = document.getElementById("reset");
      if (reset) {
        reset.addEventListener("click", resetZoom);
      }
    }, 1000);
  };

  function restoreCanvasState() {
    const savedState = localStorage.getItem("canvasState");
    if (savedState) {
      const canvasState = JSON.parse(savedState);
      if (canvasRef.current) {
        canvasRef.current.setZoom(zoomLevel);
        if (canvasRef.current.viewportTransform) {
          canvasRef.current.viewportTransform[4] = canvasState.panOffsetX;
          canvasRef.current.viewportTransform[5] = canvasState.panOffsetY;
        }

        canvasRef.current.requestRenderAll();
      }
    }
  }

  function saveCanvasState() {
    const zoomLevelNew = canvasRef.current!.getZoom();
    const panOffsetX = canvasRef.current!.viewportTransform![4];
    const panOffsetY = canvasRef.current!.viewportTransform![5];
    const canvasState = {
      zoomLevel: zoomLevel,
      panOffsetX: panOffsetX,
      panOffsetY: panOffsetY,
    };

    setZoomLevel(zoomLevelNew);
    localStorage.setItem("canvasState", JSON.stringify(canvasState));
  }

  const calculateCircleRadius = () => {
    canvasRef.current!.forEachObject(function (object) {
      if (object.type === "circle") {
        const circle = object as fabric.Circle;

        // Calculate the new radius for the current circle object
        let newRadius =
          calculateCornerSize() / (canvasRef.current!.getZoom() * 2);

        // Set the new radius for the current circle object
        circle.set({
          radius: newRadius,
        });

        // Call the object's setCoords method to ensure its properties are updated
        object.setCoords();
      }
    });
  };

  //#region Check Boundaries
  function checkBoundaries(object: fabric.Object) {
    if (object && canvasRef.current) {
      // if (canvas.width && canvas.height) {
      // Calculate the maximum allowed values for left and top
      let maxLeft = canvasRef.current?.width! - object.getScaledWidth();
      let maxTop = canvasRef.current?.height! - object.getScaledHeight();

      // Ensure that left and top are within the canvas boundaries
      object.set({
        left: Math.max(0, Math.min(object.left!, maxLeft)),
        top: Math.max(0, Math.min(object.top!, maxTop)),
      });

      // Calculate the right and bottom edges of the object
      let rightEdge = object.left! + object.getScaledWidth();
      let bottomEdge = object.top! + object.getScaledHeight();

      // Adjust the right and bottom edges if they go beyond the canvas boundaries
      if (rightEdge > canvasRef.current?.width!) {
        object.set({
          left: canvasRef.current?.width! - object.getScaledWidth(),
        });
      }

      if (bottomEdge > canvasRef.current?.height!) {
        object.set({
          top: canvasRef.current?.height! - object.getScaledHeight(),
        });
      }

      // Make sure to call `setCoords()` to update the object's coordinates properly
      object.setCoords();

      canvasRef.current!.renderAll();
      // }
    }
  }
  //#endregion

  //#region polygon position handler
  function polygonPositionHandler(
    tmpPolygonObject: CustomPolygon,
    pointIndex: number
  ) {
    const points = tmpPolygonObject.points as fabric.Point[];
    const pathOffset = tmpPolygonObject.pathOffset as fabric.Point;

    const x = points![pointIndex].x - pathOffset.x,
      y = points![pointIndex].y - pathOffset.y;

    return fabric.util.transformPoint(
      new fabric.Point(x, y),
      //commented this
      //{ x: x, y: y },
      fabric.util.multiplyTransformMatrices(
        tmpPolygonObject.canvas?.viewportTransform || [1, 0, 0, 1, 0, 0],
        tmpPolygonObject.calcTransformMatrix()
      )
    );
  }
  //#endregion

  function getTopObjectUnderPointer(pointer: Point) {
    var objects = canvasRef.current!.getObjects();
    var smallestArea = Number.MAX_VALUE;
    var target = null;

    for (var i = 0; i < objects.length; i++) {
      var object = objects[i];
      // var zoom = canvas.getZoom()
      var objLeft = object.left! - 5;
      var objTop = object.top! - 5;
      var objWidth = object?.width! * object.scaleX! + 10;
      var objHeight = object?.height! * object.scaleY! + 10;

      if (
        pointer.x >= objLeft &&
        pointer.x <= objLeft + objWidth &&
        pointer.y >= objTop &&
        pointer.y <= objTop + objHeight
      ) {
        var area = objWidth * objHeight;
        if (area < smallestArea) {
          smallestArea = area;
          target = object;
        }
      }
    }

    return target;
  }

  //#region Select annotation from Canvas
  const selectAnnotationFromCanvas = (target: CustomFabricObject) => {
    if (target) {
      let labelIndex = selectedImageRef.current!.annotations.findIndex(
        (obj) => obj.annotationId === target.id
      );

      const AnnoDetails = selectedImageRef.current!.annotations[labelIndex];

      const labelDetails = {
        value: AnnoDetails.lableId,
        label: AnnoDetails.projectLabel,
        color: AnnoDetails.labelColor,
      };

      setSelectedLabel(labelDetails);
      setSelectedValue(AnnoDetails.lableId);

      const fabricObject = canvasRef.current!.item(
        labelIndex
      ) as unknown as fabric.Object;
      if (fabricObject) {
        canvasRef.current!.setActiveObject(fabricObject);
        if (fabricObject.type === "polygon") {
          if (EditPolygonRef.current) {
            EditPolygonRef.current();
          }
        }
        canvasRef.current!.renderAll();
      }
    }
  };
  //#endregion

  const removeLastObject = () => {
    const allAnno = canvasRef.current!.getObjects();

    let lastAnno: CustomFabricObject = allAnno[allAnno.length - 1];
    if (selectedTool === "poly") {
      allAnno.forEach(function (object) {
        if (object.type === "polygon") {
          lastAnno = allAnno[allAnno.length - 2];
        }
      });
    }

    if (allAnno.length > 0 && lastAnno) {
      if (lastAnno.type !== "circle" && !lastAnno.id) {
        if (selectedImageRef.current) {
          let index = selectedImageRef.current!.annotations.findIndex(
            (obj) => obj.annotationId === (lastAnno as any).id
          );

          if (index === -1) {
            canvasRef.current!.remove(lastAnno);
            canvasRef.current!.renderAll();
          }
        }
      }
    }
  };

  function adjustObjectSizes() {
    var zoomFactor = canvasRef.current!.getZoom();
    if (zoomFactor > 1) {
      canvasRef.current!.forEachObject(function (object) {
        // Adjust width, height, and corner size based on zoom factor
        object.set({
          cornerSize: calculateCornerSize() / zoomFactor,
        });
        object.setCoords(); // Update object coordinates
      });
    } else {
      canvasRef.current!.forEachObject(function (object) {
        // Adjust width, height, and corner size based on zoom factor
        object.set({
          cornerSize: calculateCornerSize(),
        });
        object.setCoords(); // Update object coordinates
      });
    }
    canvasRef.current!.renderAll(); // Render the updated canvas
  }

  //#region Apply Zoom
  const applyZoom = async (zoomPoint: fabric.Point, zoomLevel: number) => {
    if (zoomLevel >= 5) {
      return;
    }

    canvasRef.current!.zoomToPoint(zoomPoint, zoomLevel);

    const canvasWidth = canvasRef.current!.getWidth();
    const canvasHeight = canvasRef.current!.getHeight();

    let viewportTransform = canvasRef.current!.viewportTransform!.slice();

    viewportTransform[4] = Math.min(0, viewportTransform[4]); // left edge
    viewportTransform[5] = Math.min(0, viewportTransform[5]); // top edge

    // Calculate zoomed dimensions
    const zoomedWidth = canvasWidth * zoomLevel;
    const zoomedHeight = canvasHeight * zoomLevel;

    // Adjust for right and bottom edges
    viewportTransform[4] = Math.max(
      viewportTransform[4],
      canvasWidth - zoomedWidth
    ); // right edge
    viewportTransform[5] = Math.max(
      viewportTransform[5],
      canvasHeight - zoomedHeight
    ); // bottom edge

    // Apply the updated viewport transform
    canvasRef.current!.setViewportTransform(viewportTransform);

    let initialStrokeWidth = await calculateStrokeWidth();

    let strokeWidth = 0;
    if (initialStrokeWidth) {
      strokeWidth = initialStrokeWidth / canvasRef.current!.getZoom();
    }

    //strokeWidth = 3;
    //changed here

    // if (initialStrokeWidth) {
    //   if (initialStrokeWidth > 10 && zoomLevel > 3) {
    //     strokeWidth = 2;
    //   } else {
    //     strokeWidth = initialStrokeWidth / canvas!.getZoom();
    //     strokeWidth = parseFloat(strokeWidth.toFixed(2));
    //   }
    // }

    for (let object of canvasRef.current!.getObjects()) {
      // if (object.type === "polygon") {
      //   canvas!.remove(object);

      //   const imageSize = await loadImgPromise(
      //     `${process.env.REACT_APP_SERVER_BASEURL}${selectedImage.imageUrl}`
      //   );

      //   selectedImage.annotations.forEach((annotation) => {
      //     if (annotation.type === "Polygon") {
      //       let cornerSize = calculateCornerSize();
      //       const data = annotation.annotation[0];

      //       const dataArray = data.split(",").map(Number);

      //       const coordinates = [];
      //       for (let i = 0; i < dataArray.length; i += 2) {
      //         coordinates.push({
      //           x: dataArray[i] * imageSize.naturalWidth,
      //           y: dataArray[i + 1] * imageSize.naturalHeight,
      //         });
      //       }

      //       const fillColor = lightenColor(annotation.labelColor, 0);

      //       var polygon = new fabric.Polygon(coordinates, {
      //         fill: fillColor,
      //         stroke: "black",
      //         strokeWidth: strokeWidth!,
      //         objectCaching: false,
      //         transparentCorners: false,
      //         cornerColor: "yellow",
      //         strokeUniform: true,
      //         cornerSize: cornerSize,
      //         selectable: false,
      //         perPixelTargetFind: true,
      //       }) as CustomPolygon;

      //       polygon.id = annotation.annotationId;

      //       polygon.setControlsVisibility({
      //         mtr: false,
      //       });
      //       if (canvasRef.current) {
      //         canvasRef.current.add(polygon);
      //       }
      //       if (previousActiveObjectId === polygon.id) {
      //         if (canvasRef.current) {
      //           canvasRef.current.setActiveObject(polygon);
      //         }
      //         if (EditPolygonRef.current) {
      //           EditPolygonRef.current();
      //         }
      //       }

      //       if (canvasRef.current) {
      //         canvasRef.current.renderAll();
      //       }
      //     }
      //   });
      //   canvas!.renderAll();
      // } else {
      object.set("strokeWidth", strokeWidth);
      // }
    }

    calculateCircleRadius();
    saveCanvasState();
  };
  //#endregion

  //#region Zoom In
  const zoomIn = async () => {
    let newZoom = canvasRef.current!.getZoom() * 1.1;
    if (newZoom <= 5.0) {
      setZoomLevel(newZoom);

      const canvasCenter = new fabric.Point(
        canvasRef.current!.width! / 2,
        canvasRef.current!.height! / 2
      );

      applyZoom(canvasCenter, newZoom);
    }
  };
  //#endregion

  //#region Zoom Out
  const zoomOut = async () => {
    let newZoom = canvasRef.current!.getZoom() / 1.1;
    if (newZoom >= 1) {
      setZoomLevel(newZoom);

      // Calculate the center of the viewport
      const canvasCenter = new fabric.Point(
        canvasRef.current!.width! / 2,
        canvasRef.current!.height! / 2
      );

      // Calculate the zoom point based on the current viewport transform
      const viewportCenter = fabric.util.transformPoint(
        canvasCenter,
        fabric.util.invertTransform(canvasRef.current!.viewportTransform!)
      );
      applyZoom(viewportCenter, newZoom);
    } else if (newZoom < 1) {
      if (resetZoomRef.current) {
        resetZoomRef.current();
      }
    }
  };
  //#endregion

  let cH = document.getElementById("crosshair-h");
  let cV = document.getElementById("crosshair-v");
  let canvas1 = document.getElementById("canvasId");

  //#region Function to track mouse pointer
  function trackMouse(e: MouseEvent) {
    if (selectedImageRef.current) {
      if (canvas1) {
        var rect = canvas1.getBoundingClientRect();
        var mouseX = e.clientX - rect.left;
        var mouseY = e.clientY - rect.top;

        if (
          mouseX < 0 ||
          mouseY < 0 ||
          mouseX > rect?.width ||
          mouseY > rect?.height
        ) {
          // Mouse pointer is outside the canvas
          hideCrosshairs();
        } else {
          if (
            toolRef.current === "poly" ||
            toolRef.current === "rect" ||
            toolRef.current === "magicWand"
          ) {
            showCrosshairs();
          } else {
            hideCrosshairs();
          }
        }
      }

      if (canvas1) {
        let rect = canvas1.getBoundingClientRect();
        let x = 0,
          y = 0;

        // Handle touch events
        if (e instanceof TouchEvent) {
          const touch = e.touches[0]; // Get the first touch point
          x = touch.clientX - rect.left;
          y = touch.clientY - rect.top;
        }
        // Handle mouse events
        else if (e instanceof MouseEvent) {
          x = e.clientX - rect.left;
          y = e.clientY - rect.top;
        }

        // Ensure crosshair stays within canvas boundaries
        if (x >= 0 && x <= rect?.width) {
          cV!.style.left =
            (e instanceof TouchEvent ? e.touches[0].pageX : e.pageX) + "px";
        }
        if (y >= 0 && y <= rect?.height) {
          cH!.style.top =
            (e instanceof TouchEvent ? e.touches[0].pageY : e.pageY) + "px";
        }
      }
    }
  }
  //#endregion

  function hideCrosshairs() {
    if (cH && cV) {
      cH.style.display = "none";
      cV.style.display = "none";
    }
  }

  function showCrosshairs() {
    if (cH && cV) {
      cH.style.display = "block";
      cV.style.display = "block";
    }
  }

  //#region Update Cross Hair Position
  function updateCrosshairPosition(e: MouseEvent | TouchEvent) {
    if (canvas1) {
      var rect = canvas1.getBoundingClientRect();
      let x = 0,
        y = 0;

      // Handle touch events
      if (e instanceof TouchEvent) {
        const touch = e.touches[0]; // Get the first touch point
        x = touch.clientX - rect.left;
        y = touch.clientY - rect.top;
      }
      // Handle mouse events
      else if (e instanceof MouseEvent) {
        x = e.clientX - rect.left;
        y = e.clientY - rect.top;
      }

      // Ensure crosshair stays within canvas boundaries
      if (x >= 0 && x <= rect?.width) {
        cV!.style.left =
          (e instanceof TouchEvent ? e.touches[0].pageX : e.pageX) + "px";
      }
      if (y >= 0 && y <= rect?.height) {
        cH!.style.top =
          (e instanceof TouchEvent ? e.touches[0].pageY : e.pageY) + "px";
      }
    }
    e.stopPropagation();
  }
  //#endregion

  useEffect(() => {
    const container = document.getElementById("imageContainer");

    if (container) {
      const handleWheel = (event: WheelEvent) => {
        event.preventDefault();
        container.scrollLeft += event.deltaY;
        container.scrollLeft += event.deltaX;
      };

      container.addEventListener("wheel", handleWheel);

      return () => {
        container.removeEventListener("wheel", handleWheel);
      };
    }
  }, [annotationImages]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !isPinned &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPinned]);

  useEffect(() => {
    if (isOpen) {
      localStorage.setItem("showAnnotateLabelDrawer", true.toString());
    } else {
      localStorage.setItem("showAnnotateLabelDrawer", false.toString());
    }
  }, [isOpen]);

  const maxLableLimit = parseInt(localStorage.getItem("maxLableLimit") ?? "0");
  const [maxLabelCount, setMaxLabelCount] = React.useState(false);
  const handleMaxLabelCountClose = () => {
    setMaxLabelCount(false);
  };

  const handleButtonClick = (event: SyntheticEvent) => {
    event.stopPropagation();
    if (maxLableLimit <= labels.length) {
      setMaxLabelCount(true);
      setSelectedProjectLabelIdForEdit(null);
      setLabelName("");
      setShowDiv(false);
    } else {
      setMaxLabelCount(false);
      setSelectedProjectLabelIdForEdit(null);
      //setObjectTracking(false);
      setLabelName("");
      setShowDiv(true);
    }
  };

  const handleChange = async (event: SelectChangeEvent<string>) => {
    const activeObject = canvasRef.current!.getActiveObject();
    const selectedId = event.target.value as string;
    if (activeObject) {
      //dispatch(startSpinner());
      let editableIndex = selectedImage!.annotations.findIndex(
        (obj) => obj.annotationId === selectedAnnotationId
      );

      if (editableIndex !== -1) {
        const annotationDetails = selectedImage!.annotations[editableIndex];

        const annotationSaveData = {
          type: annotationDetails.type,
          annotation: annotationDetails.annotation.toString(),
          annotationId: annotationDetails.annotationId,
          projectLabelId: selectedId,
          projectImageId: selectedImageRef.current!.id,
          projectId: id,
        };

        const response = await dispatch(updateAnnotation(annotationSaveData));
        if (response) {
          dispatch(fetchLabelDetails(selectedImage!.id));
          toast.success("label updated successfully");

          setIsImageChanged(false);

          const updated = { ...selectedImageRef.current! };

          updated.annotations = updated.annotations.map((ann) =>
            ann.annotationId === annotationSaveData.annotationId
              ? {
                  ...ann,
                  projectLabelId: selectedId,
                }
              : ann
          );

          selectedImageRef.current = updated;

          dispatch(
            updateImageInList({
              id: updated.id,
              updatedImage: updated,
            })
          );

          setSelectedImage(selectedImageRef.current);
        }

        setPreviousActiveObjectId(annotationDetails.annotationId);
      }
    }

    const selectedLabelDetails = labels.find(
      (label) => label.id === selectedId
    );

    if (selectedLabelDetails) {
      const tmpSelectedLabel = {
        value: selectedId,
        label: selectedLabelDetails.name,
        color: selectedLabelDetails.labelColor,
      };
      setSelectedLabel(tmpSelectedLabel);
      if (selectedLabelColorRef.current) {
        selectedLabelColorRef.current = selectedLabelDetails.labelColor;
      }
    }

    setSelectedValue(event.target.value);
    labelRef.current!.value = event.target.value;
  };

  //#region Load Previous Annotations
  const loadPreviousAnnotations = async () => {
    try {
      if (selectedImageRef.current) {
        if (canvasRef.current) {
          const objectsToRemove = canvasRef.current.getObjects();

          objectsToRemove.forEach((obj) => {
            canvasRef.current?.remove(obj);
          });
        }

        const url = selectedImageRef.current.imageUrl.toLowerCase();
        const imageSize = await loadImgPromise(
          `${process.env.REACT_APP_SERVER_BASEURL}${url}`
        );

        imageSizeRef.current = imageSize;
        let initialStrokeWidth = await calculateStrokeWidth();
        let strokeWidth = 0;

        if (initialStrokeWidth && canvasRef.current) {
          strokeWidth = initialStrokeWidth / canvasRef.current.getZoom();
        }

        let cornerSize = calculateCornerSize();

        selectedImageRef.current.annotations.forEach((annotation) => {
          if (annotation.type === "Rectangle") {
            const [left, top, width, height] = annotation.annotation[0]
              .split(",")
              .map(parseFloat);

            const leftValue = left * imageSize.naturalWidth;
            const topValue = top * imageSize.naturalHeight;
            const widthValue = width * imageSize.naturalWidth;
            const heightValue = height * imageSize.naturalHeight;

            const fillColor = lightenColor(annotation.labelColor, 0);

            // Create Fabric.js rectangle
            const rect = new fabric.Rect({
              left: leftValue,
              top: topValue,
              width: widthValue,
              height: heightValue,
              fill: fillColor,
              stroke: "black",
              padding: -(strokeWidth * 1.5),
              strokeWidth: strokeWidth,
              objectCaching: false,
              strokeUniform: true,
              cornerSize: cornerSize,
              selectable: false,
              hasBorders: false,
            }) as CustomRect;

            rect.id = annotation.annotationId;

            fabric.Object.prototype.transparentCorners = false;
            fabric.Object.prototype.cornerColor = "white";
            fabric.Object.prototype.cornerStyle = "circle";
            fabric.Object.prototype.cornerStrokeColor = "black";
            (fabric.Object.prototype as any).cornerStrokeWidth = "3";
            fabric.Rect.prototype._controlsVisibility = {
              mtr: false,
            };

            if (canvasRef.current) {
              canvasRef.current.add(rect);
            }

            if (previousActiveObjectId === rect.id) {
              if (canvasRef.current) {
                canvasRef.current.setActiveObject(rect);
              }
            }
          } else if (annotation.type === "Polygon") {
            const data = annotation.annotation[0];

            const dataArray = data.split(",").map(Number);

            const coordinates = [];
            for (let i = 0; i < dataArray.length; i += 2) {
              coordinates.push({
                x: dataArray[i] * imageSize.naturalWidth,
                y: dataArray[i + 1] * imageSize.naturalHeight,
              });
            }

            const fillColor = lightenColor(annotation.labelColor, 0);

            var polygon = new fabric.Polygon(coordinates, {
              fill: fillColor,
              stroke: "black",
              //changed here
              strokeWidth: strokeWidth,
              objectCaching: false,
              transparentCorners: false,
              cornerColor: "yellow",
              strokeUniform: true,
              cornerSize: cornerSize,
              selectable: false,
              perPixelTargetFind: true,
            }) as CustomPolygon;

            polygon.id = annotation.annotationId;

            polygon.setControlsVisibility({
              mtr: false,
            });
            if (canvasRef.current) {
              canvasRef.current.add(polygon);
            }
            if (previousActiveObjectId === polygon.id) {
              if (canvasRef.current) {
                canvasRef.current.setActiveObject(polygon);
              }
              if (EditPolygonRef.current) {
                EditPolygonRef.current();
              }
            }

            if (canvasRef.current) {
              canvasRef.current.renderAll();
            }
          }
        });
      }
    } catch (error) {
      toast.error("Error in load Previous Annotations");
      dispatch(stopSpinner());
    }
  };
  //#endregion

  //#region Draw Annotations
  const drawAnnotations = async (annotation: any) => {
    if (selectedImageRef.current && canvasRef.current) {
      const allAnno = canvasRef.current!.getObjects();

      allAnno.forEach(function (object: CustomFabricObject) {
        if (!object.id) {
          canvasRef.current!.remove(object);
          canvasRef.current!.renderAll();
        }
      });

      let initialStrokeWidth = await calculateStrokeWidth();
      let strokeWidth = 0;

      if (initialStrokeWidth && canvasRef.current) {
        strokeWidth = initialStrokeWidth / canvasRef.current.getZoom();
      }

      let cornerSize = calculateCornerSize();

      if (annotation.type === "Rectangle") {
        const [left, top, width, height] = annotation.annotation[0]
          .split(",")
          .map(parseFloat);

        const leftValue = left * imageSizeRef.current!.naturalWidth;
        const topValue = top * imageSizeRef.current!.naturalHeight;
        const widthValue = width * imageSizeRef.current!.naturalWidth;
        const heightValue = height * imageSizeRef.current!.naturalHeight;

        const fillColor = lightenColor(annotation.labelColor, 0);

        // Create Fabric.js rectangle
        const rect = new fabric.Rect({
          left: leftValue,
          top: topValue,
          width: widthValue,
          height: heightValue,
          fill: fillColor,
          stroke: "black",
          padding: -(strokeWidth * 1.5),
          strokeWidth: strokeWidth,
          objectCaching: false,
          strokeUniform: true,
          cornerSize: cornerSize,
          selectable: false,
          hasBorders: false,
        }) as CustomRect;

        rect.id = annotation.annotationId;

        fabric.Object.prototype.transparentCorners = false;
        fabric.Object.prototype.cornerColor = "white";
        fabric.Object.prototype.cornerStyle = "circle";
        fabric.Object.prototype.cornerStrokeColor = "black";
        (fabric.Object.prototype as any).cornerStrokeWidth = "3";
        fabric.Rect.prototype._controlsVisibility = {
          mtr: false,
        };

        if (canvasRef.current) {
          canvasRef.current.add(rect);
        }

        if (previousActiveObjectId === rect.id) {
          if (canvasRef.current) {
            canvasRef.current.setActiveObject(rect);
          }
        }
      } else if (annotation.type === "Polygon") {
        const data = annotation.annotation[0];

        const dataArray = data.split(",").map(Number);

        const coordinates = [];
        for (let i = 0; i < dataArray.length; i += 2) {
          coordinates.push({
            x: dataArray[i] * imageSizeRef.current!.naturalWidth,
            y: dataArray[i + 1] * imageSizeRef.current!.naturalHeight,
          });
        }

        const fillColor = lightenColor(annotation.labelColor, 0);

        var polygon = new fabric.Polygon(coordinates, {
          fill: fillColor,
          stroke: "black",
          //changed here
          strokeWidth: strokeWidth,
          objectCaching: false,
          transparentCorners: false,
          cornerColor: "yellow",
          strokeUniform: true,
          cornerSize: cornerSize,
          selectable: false,
          perPixelTargetFind: true,
        }) as CustomPolygon;

        polygon.id = annotation.annotationId;

        polygon.setControlsVisibility({
          mtr: false,
        });
        if (canvasRef.current) {
          canvasRef.current.add(polygon);
        }
        if (previousActiveObjectId === polygon.id) {
          if (canvasRef.current) {
            canvasRef.current.setActiveObject(polygon);
          }
          if (EditPolygonRef.current) {
            EditPolygonRef.current();
          }
        }

        if (canvasRef.current) {
          canvasRef.current.renderAll();
        }
      }
    }
    dispatch(fetchLabelDetails(selectedImageRef.current!.id));
  };
  //#endregion

  useEffect(() => {
    if (id) {
      dispatch(fetchProjectById(id))
        .then((response) => {
          setProjectDetails(response?.payload);
        })
        .catch((error) => {
          console.error("Fetch Project Failed:", error); // Log error on failure
        });
    }
  }, []);

  const findNameById = (id: string) => {
    const item = tasks.find((entry) => entry.id === id);
    return item ? item.name : undefined;
  };

  useEffect(() => {
    const selectedProjectStr = localStorage.getItem("selectedProject");

    const selectedProject = selectedProjectStr
      ? JSON.parse(selectedProjectStr)
      : null;

    console.log("selectedProjectStr", selectedProject);
    // Only assign if selectedImageRef.current is not null and property exists
    setTaskTypes(selectedProject.taskTypeId);
  }, [project]);

  //#region Save Annotation Label
  const saveAnnotationLabel = async (e: React.FormEvent) => {
    toast.dismiss();
    e.preventDefault();
    if (!labelName) {
      toast.error("Please enter Label Name");
      return;
    }

    const taskId: string | undefined = project?.taskTypeId;
    const taskName = taskId ? findNameById(taskId) : "Invalid ID";

    let objectTrackingVariable = false;

    if (taskName?.toLowerCase().includes("tracking")) {
      objectTrackingVariable = true;
    }

    const data = {
      id: selectedProjectLabelIdForEdit ? selectedProjectLabelIdForEdit : "",
      name: labelName.trim(),
      description: "Default Description",
      projectId: id,
      type: "Rectangle",
      objectTracking: objectTrackingVariable,
      // slNo: 1,
      labelColor: selectedColor,
    };
    dispatch(startSpinner("Saving project label"));

    try {
      if (selectedProjectLabelIdForEdit) {
        await dispatch(editProjectLabel(data))
          .unwrap()
          .then(() => {
            const data = {
              labelId: selectedProjectLabelIdForEdit,
              color: selectedColor,
            };
            dispatch(updateLabelColor(data));
            if (selectedImage) {
              const fillColor = lightenColor(selectedColor, 0);
              selectedImage.annotations.map((anno) => {
                for (let object of canvasRef.current!.getObjects()) {
                  const fabricObject = object as CustomFabricObject;
                  if (anno.lableId === selectedProjectLabelIdForEdit) {
                    if (fabricObject.id === anno.annotationId) {
                      object.set("fill", fillColor);
                      canvasRef.current!.renderAll();
                    }
                  }
                }
              });

              dispatch(fetchLabelDetails(selectedImage.id));

              if (selectedProjectLabelIdForEdit === selectedValue) {
                selectedLabelColorRef.current = selectedColor;
              }
            }
            toast.success("Project Label updated Successfully");
          });
        //await dispatch(fetchProjectLabels);
      } else {
        await dispatch(addProjectLabels(data))
          .unwrap()
          .then((response) => {
            allLabelRef.current = [...allLabelRef.current, response];
            toast.success("Project Label added Successfully");
          });
      }
    } catch (error) {
      //toast.error("Failed to save Label");
    } finally {
      dispatch(stopSpinner());
      setShowDiv(false);
      //setObjectTracking(false);
      setLabelName("");
      setSelectedProjectLabelIdForEdit(null);
    }
  };
  //#endregion

  //#region Cancel Label Creation
  const cancelLabelCreation = () => {
    setSelectedProjectLabelIdForEdit(null);
    //setObjectTracking(false);
    setLabelName("");
    setShowDiv(false);
  };
  //#endregion

  const handleClick = (tool: string) => {
    if (tool === "poly" || tool === "magicWand") {
      setTmpRectanglePoints(null);
    }
    setSelectedTool(tool);
    toolRef.current = tool;

    if (
      toolRef.current === "rect" ||
      toolRef.current === "poly" ||
      toolRef.current === "magicWand"
    ) {
      canvasRef.current!.defaultCursor = "crosshair";
    }

    if (toolRef.current === "select" || toolRef.current === "rect") {
      if (canvasRef.current) {
        canvasRef.current.selection = false;
      }
    }

    if (tool === "rect") {
      if (handleRectangleToolRef.current) {
        handleRectangleToolRef.current();
      }
    } else if (tool === "poly") {
      if (addPolygonRef.current) {
        addPolygonRef.current();
      }
    } else if (tool === "magicWand") {
      if (handleMagicWandToolRef.current) {
        handleMagicWandToolRef.current();
      }
    }
  };

  //#region Handle Label Change
  const handleLableChange = async (selectedOption: ProjectLabels) => {
    let activeObject;
    if (canvasRef.current) {
      activeObject = canvasRef.current.getActiveObject();
    }

    if (activeObject) {
      let editableIndex = selectedImage!.annotations.findIndex(
        (obj) => obj.annotationId === selectedAnnotationId
      );

      if (editableIndex !== -1) {
        const annotationDetails = selectedImage!.annotations[editableIndex];

        const annotationSaveData = {
          type: annotationDetails.type,
          annotation: annotationDetails.annotation.toString(),
          annotationId: annotationDetails.annotationId,
          projectLabelId: selectedOption.value,
          projectImageId: selectedImage!.id,
          projectId: id,
        };

        setPreviousActiveObjectId(annotationDetails.annotationId);

        const index = annotationImages.findIndex(
          (obj) => obj.id === selectedImage!.id
        );
        loadImageDetails(annotationImages[index].id);
      }
    }

    setSelectedLabel(selectedOption);

    if (saveLabelDetailsRef.current) {
      saveLabelDetailsRef.current(selectedOption);
    }
  };
  //#endregion

  React.useEffect(() => {
    if (tmprectanglePoints) {
      saveAnnotation();
    }
  }, [tmprectanglePoints]);

  React.useEffect(() => {
    if (polygonPoints) {
      saveAnnotation();
    }
  }, [polygonPoints]);

  //#region Save Annotation
  const saveAnnotation = async () => {
    toast.dismiss();
    dispatch(startSpinner("Saving Annotation..."));
    // try {
    if (labels.length === 0) {
      toast.error("Add label to start annotating");
      if (canvasRef.current) {
        const activeObject =
          canvasRef.current.getActiveObject() as CustomFabricObject;
        canvasRef.current.remove(activeObject);
      }
      dispatch(stopSpinner());
      return;
    }

    if (!selectedLabel.value) {
      toast.error("Select Label");
      if (canvasRef.current) {
        const activeObject =
          canvasRef.current.getActiveObject() as CustomFabricObject;
        canvasRef.current.remove(activeObject);
      }
      dispatch(stopSpinner());
      return;
    }

    if (selectedImageRef.current) {
      let editableIndex = selectedImageRef.current.annotations.findIndex(
        (obj) => obj.annotationId === selectedAnnotationId
      );

      if (editableIndex !== -1) {
        const annotationDetails =
          selectedImageRef.current.annotations[editableIndex];

        const annotationSaveData = {
          type: annotationDetails.type,
          annotation: annotationDetails.annotation.toString(),
          annotationId: annotationDetails.annotationId,
          projectLabelId: selectedLabel.value,
          projectImageId: selectedImageRef.current.id,
          projectId: id,
        };

        const response = await dispatch(updateAnnotation(annotationSaveData));
        if (response) {
        }
        setIsImageChanged(false);

        const updated = { ...selectedImageRef.current! };

        updated.annotations = updated.annotations.map((ann) =>
          ann.annotationId === annotationSaveData.annotationId
            ? {
                ...ann,
                projectLabelId: selectedLabel.value,
                projectImageId: selectedImageRef.current!.id,
              }
            : ann
        );

        selectedImageRef.current = updated;

        dispatch(
          updateImageInList({
            id: updated.id,
            updatedImage: updated,
          })
        );

        const index = annotationImages.findIndex(
          (obj) => obj.id === selectedImageRef.current!.id
        );

        setPreviousActiveObjectId(null);
        //loadImageDetails(annotationImages[index].id);
        setSelectedImage(annotationImages[index]);
        selectedImageRef.current = annotationImages[index];
        canvasRef.current!.discardActiveObject();
        canvasRef.current!.renderAll();
        setSelectedAnnotationId(null);
        return;
      }

      setIsAnnoSaving(true);

      if (selectedTool === "rect") {
        let hasError = false;

        let zeroCount = 0;

        for (var j = 0; j <= tmprectanglePoints!.length; j++) {
          if (tmprectanglePoints![j] <= 0) {
            zeroCount = zeroCount + 1;
            hasError = true;
          }
        }

        if (hasError || zeroCount > 0) {
          toast.error("Can't save Annotation");
          const activeObject =
            canvasRef.current!.getActiveObject() as CustomFabricObject;
          if (canvasRef.current) {
            canvasRef.current.remove(activeObject);
          }
          return;
        }

        const rectanglePoints = await convertToRectStringArray(
          tmprectanglePoints!
        );

        const annotationSaveData = {
          type: "Rectangle",
          annotation: rectanglePoints,
          annotationId: uuidv4(),
          projectLabelId: selectedLabel.value,
          projectImageId: selectedImageRef.current.id,
          projectId: id,
        };

        await dispatch(saveImageAnnotation(annotationSaveData))
          .unwrap()
          .then((response) => {
            setPreviousActiveObjectId(null);
            setTmpRectanglePoints(null);
            dispatch(stopSpinner());
            setIsImageChanged(false);

            const tmpAnnotation = {
              type: "Rectangle",
              annotation: [annotationSaveData.annotation],
              annotationId: annotationSaveData.annotationId,
              labelColor: selectedLabel.color,
              lableId: selectedLabel.value,
              projectLabel: selectedLabel.label,
            };

            drawAnnotations(tmpAnnotation);

            let updated1 = { ...selectedImageRef.current! };
            const updated = {
              ...updated1,
              annotations: [...updated1.annotations, tmpAnnotation],
            };
            updated.annotationsCount = updated.annotations.length;

            if (updated.annotationsCount === 1) {
              updated.isAnnotated = true;
              setAnnotatedImgCount((prevState) => prevState + 1);
              setUnAnnotatedImageCount((prevState) => prevState - 1);
            }

            dispatch(
              updateImageInList({
                id: updated.id,
                updatedImage: updated,
              })
            );

            setSelectedImage(updated);
            selectedImageRef.current = updated;
          });
      } else if (selectedTool === "poly" || selectedTool === "magicWand") {
        const mappedModifiedPoly = polygonPoints!.map((value) =>
          value.x <= 0 || value.y <= 0 ? 1 : 0
        );

        // Check if the sum of mapped array is equal to 2
        const sum = mappedModifiedPoly.reduce(
          (acc: number, curr: number) => acc + curr,
          0
        );

        let hasError = sum === 1;

        const hasNegativeValues = polygonPoints!.some(
          (value) => value.x < 0 || value.y < 0
        );

        // If negative values found, force hasError to true
        if (hasNegativeValues) {
          hasError = true;
        }

        if (hasError) {
          toast.error("Can't save Annotation");
          const activeObject =
            canvasRef.current!.getActiveObject() as CustomFabricObject;
          if (canvasRef.current) {
            canvasRef.current.remove(activeObject);
          }
          dispatch(stopSpinner());
          return;
        }

        const polyPoints = await convertToPolygonStringArray(polygonPoints!);

        const annotationSaveData = {
          type: "Polygon",
          annotation: polyPoints,
          annotationId: uuidv4(),
          projectLabelId: selectedLabel.value,
          projectImageId: selectedImageRef.current.id,
          projectId: id,
        };

        await dispatch(saveImageAnnotation(annotationSaveData))
          .unwrap()
          .then((response) => {
            setIsImageChanged(false);

            const tmpAnnotation = {
              type: "Polygon",
              annotation: [annotationSaveData.annotation],
              annotationId: annotationSaveData.annotationId,
              labelColor: selectedLabel.color,
              lableId: selectedLabel.value,
              projectLabel: selectedLabel.label,
            };

            drawAnnotations(tmpAnnotation);

            let updated1 = { ...selectedImageRef.current! };
            const updated = {
              ...updated1,
              annotations: [...updated1.annotations, tmpAnnotation],
            };
            updated.annotationsCount = updated.annotations.length;

            if (updated.annotationsCount === 1) {
              updated.isAnnotated = true;
              setAnnotatedImgCount((prevState) => prevState + 1);
              setUnAnnotatedImageCount((prevState) => prevState - 1);
            }

            dispatch(
              updateImageInList({
                id: updated.id,
                updatedImage: updated,
              })
            );

            setSelectedImage(updated);
            selectedImageRef.current = updated;
          });

        if (canvasRef.current) {
          canvasRef.current.defaultCursor = "crosshair";
        }

        setPreviousActiveObjectId(null);
        setPolygonPoints(null);
      }
      setIsAnnoSaving(false);
      canvasRef.current!.discardActiveObject();
      canvasRef.current!.renderAll();
      setSelectedAnnotationId(null);
    }
    dispatch(stopSpinner());
    // } catch (e: any) {
    //   const activeObject =
    //     canvasRef.current!.getActiveObject() as CustomFabricObject;
    //   if (canvasRef.current) {
    //     canvasRef.current.remove(activeObject);
    //   }
    //   dispatch(stopSpinner());
    //   toast.error("Failed to save Annotation");
    //   console.log(e, "ceclk");
    //   // if (typeof e.response.data.errors.Annotation[0] == "string") {
    //   //   toast.error(e.response.data);
    //   // } else {
    //   //   toast.error(e.response.data.detail);
    //   // }
    // }
  };
  //#endregion

  //#region Select Anno on label click
  const selectAnnotationonLabelClick = (data: LabelProperty) => {
    if (!selectedImageRef.current?.isAnnotator || !isProjectOwner) {
      return;
    }

    const annoDetails = selectedImage?.annotations.find(
      (anno) => anno.annotationId === data.annotationId
    );

    if (annoDetails) {
      const selectedLabelInfo = {
        value: data.labelId,
        label: annoDetails.projectLabel,
        color: annoDetails.labelColor,
      };
      setSelectedLabel(selectedLabelInfo);
      setSelectedAnnotationId(annoDetails.annotationId);
      setSelectedValue(data.labelId);
      setSelectedTool("select");

      const selectButton = document.getElementById("select");
      if (selectButton) {
        selectButton.click();
      }

      let labelIndex = selectedImage!.annotations.findIndex(
        (obj) => obj.annotationId === annoDetails.annotationId
      );

      const fabricObject = canvasRef.current!.item(
        labelIndex
      ) as unknown as fabric.Object;
      if (fabricObject) {
        canvasRef.current!.setActiveObject(fabricObject);
        if (fabricObject.type === "polygon") {
          if (EditPolygonRef.current) {
            EditPolygonRef.current();
          } else {
            toast.error("Function not yet defined");
          }
        }
        canvasRef.current!.requestRenderAll();
      }
    }

    // setShowAnnotationEditor(true)
    //event.target.classList.add("selectedLabel")
  };
  //#endregion

  const deleteAnnotationById = async () => {
    const activeObject = canvasRef.current!.getActiveObject() as fabric.Object;
    if (projectAnnotationId) {
      dispatch(startSpinner("Deleting Annotation"));
      try {
        const deleteData = {
          projectImageId: selectedImage!.id,
          annotationId: projectAnnotationId,
        };

        await dispatch(deleteAnnotation(deleteData))
          .unwrap()
          .then((response) => {
            setIsImageChanged(false);

            let updated = { ...selectedImageRef.current! };

            const updatedImageObject = {
              ...updated,
              annotations: updated.annotations.filter(
                (anno: any) => anno.annotationId !== deleteData.annotationId
              ),
              annotationsCount: updated.annotationsCount - 1,
            };

            if (updatedImageObject.annotationsCount === 0) {
              setAnnotatedImgCount((prevState) => prevState - 1);
              setUnAnnotatedImageCount((prevState) => prevState + 1);
            }
            setDeleteAnnotationModal(false);
            toast.success("Annotation Deleted Successfully");

            dispatch(
              updateImageInList({
                id: updatedImageObject.id,
                updatedImage: updatedImageObject,
              })
            );

            dispatch(fetchLabelDetails(selectedImageRef.current!.id));

            setSelectedImage(updatedImageObject);
            selectedImageRef.current = updatedImageObject;
          });
      } catch (error) {
        toast.error("Failed to delete");
      } finally {
        dispatch(stopSpinner());
      }

      //filter related things, uncomment later
      // if (
      //   imageUrlModel[index]?.annotations?.length == 0 &&
      //   localStorage.getItem("currentFilter") == "with"
      // ) {
      //   localStorage.setItem("deleted", deleteData?.projectImageId);
      // }

      canvasRef.current!.remove(activeObject);
    } else {
      canvasRef.current!.remove(activeObject);
      //deleting modal needs to be opened, uncomment later
      //setOpenDeleteAnnnotationModal(false);
    }
    setSelectedAnnotationId(null);
  };

  const getAnnotationPointsWithoutDecimals = (points: number[]) => {
    const pointsData = points.map((point) => {
      return Math.round(point);
    });
    return [pointsData.join(",")];
  };

  //#region Convert to Rect String Array
  const convertToRectStringArray = async (rectanglePoints: number[]) => {
    if (selectedImageRef.current) {
      const url = selectedImageRef.current.imageUrl.toLowerCase();

      // Finding min and max values to calculate width and height
      const leftValue = rectanglePoints[0] / imageSizeRef.current!.naturalWidth;
      const topValue = rectanglePoints[1] / imageSizeRef.current!.naturalHeight;
      const widthValue =
        rectanglePoints[2] / imageSizeRef.current!.naturalWidth;
      const heightValue =
        rectanglePoints[3] / imageSizeRef.current!.naturalHeight;

      // Creating string array with left, top, width, and height
      const rectStringArray = [
        leftValue.toString(),
        topValue.toString(),
        widthValue.toString(),
        heightValue.toString(),
      ];

      const concatenatedString = rectStringArray.join(",");

      return concatenatedString;
    }
  };
  //#endregion

  //#region Convert to Polygon String Array
  const convertToPolygonStringArray = async (polygonPoints: Point[]) => {
    if (selectedImageRef.current) {
      const url = selectedImageRef.current.imageUrl.toLowerCase();

      const arrayOfStrings = polygonPoints.map(
        (point) =>
          `${point.x / imageSizeRef.current!.naturalWidth},${
            point.y / imageSizeRef.current!.naturalHeight
          }`
      );

      const concatenatedString = arrayOfStrings.join(",");

      return concatenatedString;
    }
  };
  //#endregion

  //#region Function to calculate corner size based on canvas dimensions
  function calculateCornerSize() {
    let canvasWidth: number = 0;
    let canvasHeight: number = 0;
    if (canvasRef.current) {
      canvasWidth = canvasRef.current.getWidth();
      canvasHeight = canvasRef.current.getHeight();
    }

    // Calculate corner size based on canvas dimensions
    var highestDimension = Math.max(canvasWidth, canvasHeight);
    var lowlowestDimension = Math.min(canvasWidth, canvasHeight);
    // If either width or height is less than 100, use the highest factor
    if (lowlowestDimension > 300) {
      return highestDimension * 0.015;
    } else {
      return 8;
    }
    // return cornerSize
  }
  //#endregion

  //#region to calculate strokeWidth
  const calculateStrokeWidth = async () => {
    if (selectedImageRef.current) {
      const url = selectedImageRef.current.imageUrl.toLowerCase();

      let canvasWidth = imageSizeRef.current!.naturalWidth;
      let canvasHeight = imageSizeRef.current!.naturalHeight;

      // Calculate corner size based on canvas dimensions
      var highestDimension = Math.max(canvasWidth, canvasHeight);
      var lowlowestDimension = Math.min(canvasWidth, canvasHeight);

      if (lowlowestDimension > 300) {
        return highestDimension * 0.003;
      } else if (highestDimension > 1000) {
        return highestDimension * 0.001;
      } else {
        return 1.2;
      }
    }
  };
  //#endregion

  async function getLabels() {
    try {
      await dispatch(fetchProjectLabels(id))
        .unwrap()
        .then((response) => {
          const labelDetails = response.find(
            (label: any) => label.id === selectedLabel
          );
          return labelDetails;
        });
    } catch (error) {
      return {};
    }
  }

  //#region Lighten the Color
  function lightenColor(hex: string, percent: number) {
    if (!hex) {
      const selectedLabel = labelRef.current!.value;
      const labelDetails = allLabelRef.current.find(
        (label: any) => label.id === selectedLabel
      );
      return labelDetails!.labelColor;
    }
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, "");

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let a = 0.3;

    // Increase each by the percent
    r = Math.min(255, Math.floor(r + ((255 - r) * percent) / 100));
    g = Math.min(255, Math.floor(g + ((255 - g) * percent) / 100));
    b = Math.min(255, Math.floor(b + ((255 - b) * percent) / 100));

    // Convert back to hex
    let newHex =
      "#" +
      r.toString(16).padStart(2, "0") +
      g.toString(16).padStart(2, "0") +
      b.toString(16).padStart(2, "0") +
      Math.round(a * 255)
        .toString(16)
        .padStart(2, "0");

    return newHex;
  }
  //#endregion

  const getColorName = (hex: string): string | undefined => {
    const color = colorSet.find((color) => color.value === hex);
    return color ? color.label : undefined;
  };

  const handleLabelColorChange = (event: SelectChangeEvent<string>) => {
    setSelectedColor(event.target.value);
  };

  const imageWidth = 64;
  const containerWidth = 3 * imageWidth;

  const handlePrevious = () => {
    //dispatch(startSpinner());
    setZoomLevel(1);
    let updatedIndex = currentIndex - 1;

    setCurrentIndex(updatedIndex);

    const canvasState = {
      zoomLevel: 1,
      panOffsetX: 0,
      panOffsetY: 0,
    };

    if (selectedTool === "pan") {
      setSelectedTool("select");
    }

    localStorage.setItem("canvasState", JSON.stringify(canvasState));
    const container = document.getElementById("imageContainer");
    if (container) {
      const selectedImage = container.children[updatedIndex] as HTMLElement;

      if (selectedImage) {
        const containerRect = container.getBoundingClientRect();
        const selectedImageRect = selectedImage.getBoundingClientRect();

        // Calculate the scroll offset to center the image
        const scrollOffset =
          selectedImageRect.left -
          containerRect.left -
          container.clientWidth / 2 +
          selectedImageRect.width / 2;

        // Smooth scroll to the calculated position
        container.scrollTo({
          left: container.scrollLeft + 44 + scrollOffset,
          behavior: "smooth",
        });
      }
    }

    loadImageDetails(annotationImages[updatedIndex].id);
  };

  const handleImageSelection = (index: number) => {
    setZoomLevel(1);
    setCurrentIndex(index);
    setPreviousActiveObjectId(null);
    setSelectedAnnotationId(null);

    const canvasState = {
      zoomLevel: 1,
      panOffsetX: 0,
      panOffsetY: 0,
    };

    if (selectedTool === "pan") {
      setSelectedTool("select");
    }

    localStorage.setItem("canvasState", JSON.stringify(canvasState));

    imagePosition(index);

    loadImageDetails(annotationImages[index].id);
  };

  const handleNext = () => {
    if (
      annotationImages.length === currentIndex + 2 &&
      currentPage < totalPages
    ) {
      setIsLoading(true);
    }

    //dispatch(startSpinner());
    let updatedIndex = currentIndex + 1;
    setZoomLevel(1);
    setCurrentIndex(updatedIndex);

    const canvasState = {
      zoomLevel: 1,
      panOffsetX: 0,
      panOffsetY: 0,
    };

    if (selectedTool === "pan") {
      setSelectedTool("select");
    }

    localStorage.setItem("canvasState", JSON.stringify(canvasState));
    loadImageDetails(annotationImages[updatedIndex].id);
    // Scroll the image container to center the clicked image
    imagePosition(updatedIndex);
  };

  const handleDeleteAnnotationModalOpen = (id: string) => {
    setProjectAnnotationId(id);
    setDeleteAnnotationModal(true);
  };

  const handleDeleteAnnotationModalClose = () => {
    setDeleteAnnotationModal(false);
  };

  //#region get last 3 labels
  const getLastThreeLabels = () => {
    if (labelDetails) {
      const lastThreeLabels = labelDetails
        .flatMap((item) => item.labelProperties)
        .slice(0, 3);

      const labelCounts: Record<string, number> = {};
      const labelNamesWithCountsAndColor = lastThreeLabels.map((label) => {
        const firstLetter = label.labelName[0];
        const color =
          labelDetails.find((item) => item.labelProperties.includes(label))
            ?.color || "";

        // Increment count if letter already exists, otherwise start with 1
        const count = (labelCounts[firstLetter] =
          (labelCounts[firstLetter] || 0) + 1);
        return { label: `${firstLetter}${count}`, color };
      });

      return labelNamesWithCountsAndColor;
    } else {
      return [];
    }
  };
  //#endregion

  const handleSelectAll = (index: number, isChecked: boolean) => {
    dispatch(selectAllForColor({ index, isChecked }));
  };

  const handleDeleteAllAnnotationModalOpen = () => {
    setProjectAnnotationId(id);
    setDeleteAllAnnotationModal(true);
  };

  const deleteAllAnnotationById = async () => {
    dispatch(startSpinner("Deleting annotation"));
    try {
      const selectedAnnotationIds = labelDetails.flatMap((property) =>
        property.labelProperties
          .filter((label) => label.isChecked)
          .map((label) => label.annotationId)
      );

      if (selectedImage) {
        const data = {
          annotationIds: selectedAnnotationIds,
          projectImageId: selectedImage.id,
        };

        await dispatch(deleteAllAnnotations(data))
          .unwrap()
          .then((response) => {
            setIsImageChanged(false);
            let updated = { ...selectedImageRef.current! };

            const updatedImageObject = {
              ...updated,
              annotations: updated.annotations.filter(
                (anno) => !data.annotationIds.includes(anno.annotationId)
              ),
              annotationsCount:
                updated.annotations.length -
                updated.annotations.filter((anno) =>
                  data.annotationIds.includes(anno.annotationId)
                ).length,
            };

            if (updatedImageObject.annotationsCount === 0) {
              setAnnotatedImgCount((prevState) => prevState - 1);
              setUnAnnotatedImageCount((prevState) => prevState + 1);
            }

            canvasRef
              .current!.getObjects()
              .forEach((object: CustomFabricObject) => {
                if (object.id) {
                  if (data.annotationIds.includes(object.id)) {
                    canvasRef.current!.remove(object);
                  }
                }
              });

            canvasRef.current!.renderAll();

            dispatch(stopSpinner());
            setDeleteAllAnnotationModal(false);
            toast.success("Annotations Deleted Successfully");

            dispatch(
              updateImageInList({
                id: updatedImageObject.id,
                updatedImage: updatedImageObject,
              })
            );

            dispatch(fetchLabelDetails(selectedImageRef.current!.id));

            setSelectedImage(updatedImageObject);
            selectedImageRef.current = updatedImageObject;
          });

        // if (canvasRef.current) {
        //   const objectsToRemove = canvasRef.current
        //     .getObjects()
        //     .filter((obj) =>
        //       selectedAnnotationIds.includes(
        //         (obj as CustomFabricObject).get("id") as string
        //       )
        //     );

        //   objectsToRemove.forEach((obj) => {
        //     canvasRef.current?.remove(obj);
        //   });

        //   canvasRef.current.renderAll();
        // }
      }
    } catch (e: any) {
      dispatch(stopSpinner());
      if (typeof e.response.data == "string") {
        toast.error(e.response.data);
      } else {
        toast.error(e.response);
      }
    }
  };

  const handleMenuClose = () => {
    setSelectedProjectLabelIdForEdit(null);
    setAnchorEl(null);
    setCurrentOption(null);
  };

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setCurrentOption(optionId);
  };

  const handleProjectLabelDelete = async () => {
    try {
      dispatch(startSpinner("Deleting project label"));
      if (currentOption) {
        await dispatch(deleteProjectLabel(currentOption))
          .unwrap()
          .then((result) => {
            handleMenuClose();
            setDeleteProjectLabelModal(false);
            localStorage.setItem("popupOpen", false.toString());
            toast.success("Project Label deleted Successfully");
          });
      }
      dispatch(stopSpinner());
    } catch (e) {
      setDeleteProjectLabelModal(false);
      localStorage.setItem("popupOpen", false.toString());
      handleMenuClose();
      dispatch(stopSpinner());
    }
  };

  const handleDeleteLabelClose = () => {
    setDeleteProjectLabelModal(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  const handleEditProjectLabel = async () => {
    if (currentOption) {
      setSelectedProjectLabelIdForEdit(currentOption);
      const response = await dispatch(fetchProjectLabelById(currentOption));
      const editableResult = response.payload[0];
      setLabelName(editableResult.name);
      setSelectedColor(editableResult.labelColor);
      //setObjectTracking(editableResult.objectTracking);
      setShowDiv(true);
      setAnchorEl(null);
    }
  };

  const handleImageLoad = () => {
    if (imageUrl && canvasRef.current) {
      dispatch(stopSpinner());
    }
  };

  const imagePosition = (index: number) => {
    // Scroll the image container to center the clicked image
    const container = document.getElementById("imageContainer");
    if (container) {
      const selectedImage = container.children[index] as HTMLElement;

      if (selectedImage) {
        const containerRect = container.getBoundingClientRect();
        const selectedImageRect = selectedImage.getBoundingClientRect();

        // Calculate the scroll offset to center the image
        const scrollOffset =
          selectedImageRect.left -
          containerRect.left -
          container.clientWidth / 2 +
          selectedImageRect.width / 2;

        // Smooth scroll to the calculated position
        container.scrollTo({
          left: container.scrollLeft + scrollOffset,
          behavior: "smooth",
        });
      }
    }
  };

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    dispatch(startSpinner("Preparing your canvas"));
    localStorage.setItem("imageToAnnotateId", "");

    const page = 1;
    const count = PAGE_SIZE;
    setIsToScroll(false);
    setIsImagesLoaded(false);
    setCurrentIndex(0);
    imagePosition(0);
    setCurrentPage(1);

    if (resetZoomRef.current) {
      resetZoomRef.current();
    }

    const canvasState = {
      zoomLevel: 1,
      panOffsetX: 0,
      panOffsetY: 0,
    };

    if (selectedTool === "pan") {
      setSelectedTool("select");
    }

    localStorage.setItem("canvasState", JSON.stringify(canvasState));

    if (event.target.value.toLowerCase() === "annotated") {
      // Handle Scroll function can be called only after image load is completed to the canvas
      dispatch(
        fetchImages({ projectId: id, page, count, annotation: "annotated" })
      ).then(() => setIsToScroll(true));
    } else if (event.target.value.toLowerCase() === "unannotated") {
      dispatch(
        fetchImages({ projectId: id, page, count, annotation: "unannotated" })
      ).then(() => setIsToScroll(true));
    } else {
      dispatch(
        fetchImages({ projectId: id, page, count, annotation: "all" })
      ).then(() => setIsToScroll(true));
    }
    setSelectedFilter(event.target.value);
  };

  const handlePin = () => {
    setIsPinned((prevSelected) => !prevSelected);
  };

  const handleLabelNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const sanitizedValue = e.target.value
      .replace(/^\s+/, "")
      .replace(/\s+/g, " ");
    setLabelName(sanitizedValue);
  };

  const handleScroll = () => {
    if (!isToScroll) return;
    if (isLoading) return;
    const div = observerRef.current;
    if (!div) return;

    const scrollPercentage =
      (div.scrollTop / (div.scrollHeight - div.clientHeight)) * 100;

    if (scrollPercentage >= 90 && currentPage < totalPages) {
      setIsLoading(true);
    }
  };

  useEffect(() => {
    if (!isLoading) return;
    if (!isToScroll) return;

    if (currentPage > totalPages) return;
    if (selectedFilter === "all") {
      fetchData(currentPage + 1, PAGE_SIZE, "all").then(() => {
        setCurrentPage((prevPage) => prevPage + 1);
        setIsLoading(false);
      });
    } else if (selectedFilter === "annotated") {
      dispatch(
        fetchImages({
          projectId: id,
          page: currentPage + 1,
          count: 40,
          annotation: "annotated",
        })
      ).then(() => {
        setCurrentPage((prevPage) => prevPage + 1);
        setIsLoading(false);
      });
    } else {
      dispatch(
        fetchImages({
          projectId: id,
          page: currentPage + 1,
          count: 40,
          annotation: "unannotated",
        })
      ).then(() => {
        setCurrentPage((prevPage) => prevPage + 1);
        setIsLoading(false);
      });
    }
  }, [isLoading]);

  const handleRedirectPlanPage = () => {
    const customerId = localStorage.getItem("customerId");
    window.open(
      `https://saas.unifynow.ai/price/plan?id=${customerId}_Vision_StudioPlans`,
      "_blank"
    );
  };

  const handleAIButtonClick = async () => {
    setIsLabelAssistModelopen(true);
    setConfidenceValue(10);
    loadCanvas();

    setIsAnnotationsLoading(true);
    getModelName();
  };

  const getModelName = async () => {
    try {
      let modelId = "";
      await dispatch(fetchModelDetails(id))
        .unwrap()
        .then((response) => {
          if (response) {
            modelId = response;
            if (listofAiModels.length > 0) {
              const list = listofAiModels.filter(
                (model) => model.modelId === response
              );

              if (list.length > 0) {
                setModelName(list[0].Name);
              } else {
                setModelName("No Model Found");
              }
            } else {
              loadModels(modelId);
            }
          }
        });
    } catch (error) {
      console.error("Error fetching model name:", error);
    }
  };

  const loadModels = async (modelID: string) => {
    try {
      await dispatch(fetchListOfAiModels(id))
        .unwrap()
        .then((response) => {
          if (response.length > 0) {
            const list = response.filter(
              (model: any) => model.ModelId === modelID
            );

            if (list.length > 0) {
              setModelName(list[0].Name);
            } else {
              setModelName("No Model Found");
            }
          }
        });
    } catch (error) {
      console.error("Error fetching AI models:", error);
    }
  };

  const loadCanvas = async () => {
    setTimeout(() => {
      //dispatch(startSpinner("Organizing Your Dataset"));
      if (!modalCanvasElementRef.current) {
        //dispatch(stopSpinner());
        return;
      }

      const height = window.innerHeight - 250;
      const width = window.innerWidth - 200;

      modalCanvasRef.current = new fabric.Canvas(
        modalCanvasElementRef.current,
        {
          width: width,
          height: height,
          preserveObjectStacking: true,
          selection: false,
        }
      );

      fabric.Image.fromURL(
        imageUrl,
        (img: fabric.Image | null) => {
          if (!img || !modalCanvasRef!.current) return;

          if (img) {
            // Clear previous background image
            modalCanvasRef.current!.setBackgroundImage(
              "",
              modalCanvasRef.current!.renderAll.bind(modalCanvasRef.current)
            );

            const scaleX = width / img.width!;
            const scaleY = height / img.height!;
            const scale = Math.min(scaleX, scaleY, 1);

            img.scale(scale);

            const scaledWidth = img.width! * scale;
            const scaledHeight = img.height! * scale;

            const left = (width - scaledWidth) / 2;
            const top = (height - scaledHeight) / 2;

            img.set({
              left,
              top,
              selectable: false,
              evented: false,
              // stroke: "yellow",
              // strokeWidth: 1,
            });

            modalImageBoundsRef.current = {
              left,
              top,
              right: left + scaledWidth,
              bottom: top + scaledHeight,
            };
          }

          // Set new background image
          modalCanvasRef.current!.setBackgroundImage(
            img,
            modalCanvasRef.current!.renderAll.bind(modalCanvasRef.current),
            {
              opacity: 1,
            }
          );

          //originalImageRef.current = img;
          restoreCanvasState();
          modalCanvasRef.current!.renderAll();

          // if (imageUrl && imageUrl === backgroundImageUrl) {
          //   dispatch(stopSpinner());
          // }
        },
        { crossOrigin: "anonymous" } // Use this if images are from a different origin
      );

      if (modalCanvasRef.current) {
        modalCanvasRef.current!.on(
          "mouse:wheel",
          function (opt: fabric.IEvent<WheelEvent>) {
            console.log("hitting bro!!");
            var delta = opt.e.deltaY;

            opt.e.preventDefault();
            opt.e.stopPropagation();

            var zoom = modalCanvasRef.current!.getZoom();

            zoom *= 0.999 ** delta;

            if (zoom > 5) zoom = 5;
            if (zoom < 1) {
              zoom = 1;
              resetZoom();
            }

            const pointerCoords = modalCanvasRef.current?.getPointer(opt.e);
            const pointer = new fabric.Point(
              pointerCoords!.x,
              pointerCoords!.y
            );

            zoom = Math.min(zoom);
            applyZoom(pointer, zoom);
          }
        );

        //#region Reset Image after ZoomOut
        const resetZoom = async () => {
          if (originalImageRef.current) {
            let canvasWidth = modalCanvasRef.current!.width;
            let canvasHeight = modalCanvasRef.current!.height;
            let imgWidth =
              originalImageRef.current?.width! *
              originalImageRef.current.scaleX!;
            let imgHeight =
              originalImageRef.current.height! *
              originalImageRef.current.scaleY!;
            // let bgLeft = (canvasWidth! - imgWidth) / 2;
            // let bgTop = (canvasHeight! - imgHeight) / 2;
            // Adjust background image position based on panning
            // bgLeft -=  modalCanvasRef.current!.viewportTransform![1];
            // bgTop -=  modalCanvasRef.current!.viewportTransform![1];
            // originalImageRef.current.set({
            //   left: bgLeft,
            //   top: bgTop,
            // });

            // if (toolRef.current === "pan") {
            //   tool = "select";
            //   setSelectedTool("select");
            //   canvas!.defaultCursor = "default";
            // }

            modalCanvasRef.current!.setViewportTransform([1, 0, 0, 1, 0, 0]); // Reset viewport transform
            adjustObjectSizes();
            // calculateCornerSize()
            calculateCircleRadius();

            let initialStrokeWidth = await calculateStrokeWidth();
            let strokeWidth;
            if (initialStrokeWidth) {
              strokeWidth =
                initialStrokeWidth / modalCanvasRef.current!.getZoom();
            }
            for (let object of modalCanvasRef.current!.getObjects()) {
              object.set("strokeWidth", strokeWidth);
            }
            saveCanvasState();
            modalCanvasRef.current!.requestRenderAll();
          }
        };
        //#endregion

        modalResetZoomRef.current = resetZoom;

        //#region Zoom In
        const zoomIn = async () => {
          let newZoom = modalCanvasRef.current!.getZoom() * 1.1;
          if (newZoom <= 5.0) {
            const canvasCenter = new fabric.Point(
              modalCanvasRef.current!.width! / 2,
              modalCanvasRef.current!.height! / 2
            );

            applyZoom(canvasCenter, newZoom);
          }
        };
        //#endregion

        modalZoomInRef.current = zoomIn;

        //#region Zoom Out
        const zoomOut = async () => {
          let newZoom = modalCanvasRef.current!.getZoom() / 1.1;
          if (newZoom >= 1) {
            // Calculate the center of the viewport
            const canvasCenter = new fabric.Point(
              modalCanvasRef.current!.width! / 2,
              modalCanvasRef.current!.height! / 2
            );

            // Calculate the zoom point based on the current viewport transform
            const viewportCenter = fabric.util.transformPoint(
              canvasCenter,
              fabric.util.invertTransform(
                modalCanvasRef.current!.viewportTransform!
              )
            );
            applyZoom(viewportCenter, newZoom);
          } else if (newZoom < 1) {
            if (modalResetZoomRef.current) {
              modalResetZoomRef.current();
            }
          }
        };
        //#endregion

        modalZoomOutRef.current = zoomOut;

        //#region Apply Zoom
        const applyZoom = async (
          zoomPoint: fabric.Point,
          zoomLevel: number
        ) => {
          if (zoomLevel >= 5) {
            return;
          }

          modalCanvasRef.current!.zoomToPoint(zoomPoint, zoomLevel);

          const canvasWidth = modalCanvasRef.current!.getWidth();
          const canvasHeight = modalCanvasRef.current!.getHeight();

          let viewportTransform =
            modalCanvasRef.current!.viewportTransform!.slice();

          viewportTransform[4] = Math.min(0, viewportTransform[4]); // left edge
          viewportTransform[5] = Math.min(0, viewportTransform[5]); // top edge

          // Calculate zoomed dimensions
          const zoomedWidth = canvasWidth * zoomLevel;
          const zoomedHeight = canvasHeight * zoomLevel;

          // Adjust for right and bottom edges
          viewportTransform[4] = Math.max(
            viewportTransform[4],
            canvasWidth - zoomedWidth
          ); // right edge
          viewportTransform[5] = Math.max(
            viewportTransform[5],
            canvasHeight - zoomedHeight
          ); // bottom edge

          // Apply the updated viewport transform
          modalCanvasRef.current!.setViewportTransform(viewportTransform);

          let initialStrokeWidth = await calculateStrokeWidth();

          let strokeWidth = 0;
          if (initialStrokeWidth) {
            strokeWidth =
              initialStrokeWidth / modalCanvasRef.current!.getZoom();
          }

          for (let object of modalCanvasRef.current!.getObjects()) {
            object.set("strokeWidth", strokeWidth);
          }

          calculateCircleRadius();
        };
        //#endregion
      }

      fetchLabelAssistedData();
    }, 100);
  };

  const fetchLabelAssistedData = async () => {
    try {
      const trimmedPath = selectedImageRef.current!.imageUrl.replace(
        "/api/Images/Download?path=",
        ""
      );
      const data = {
        projectId: id,
        imageURL: trimmedPath,
      };

      await dispatch(labelAssistedAnnotations(data))
        .unwrap()
        .then((response) => {
          console.log(response, "res");
          loadAIAssistedAnnotations(response);
          const uniqueLabels = Array.from(
            new Set(
              (response as AnnotationData[])
                .map((item) => item.projectLabel as string)
                .filter((label) => label?.trim()) // removes "", null, undefined, "   "
            )
          );
          setAIAssistedLabels(uniqueLabels);
          setSelectedAILabels(uniqueLabels);
          setLabelAssistedImage(response);
          setFilteredlabelAssistedImage(response);
          setIsAnnotationsLoading(false);
        });
    } catch (error) {
      toast.error(
        "Failed to load the AI Assisted Annotations. Please check Labels are mapped"
      );
    } finally {
      setIsAnnotationsLoading(false);
    }
  };

  const loadAIAssistedAnnotations = async (
    aiAssistedAnnotations: any[] | null
  ) => {
    try {
      if (modalCanvasRef.current) {
        const objectsToRemove = modalCanvasRef.current.getObjects();

        objectsToRemove.forEach((obj) => {
          modalCanvasRef.current?.remove(obj);
        });

        let initialStrokeWidth = await calculateStrokeWidth();
        let strokeWidth = 0;

        if (initialStrokeWidth && modalCanvasRef.current) {
          strokeWidth = initialStrokeWidth / modalCanvasRef.current.getZoom();
        }

        let cornerSize = calculateCornerSize();

        const imageBounds = modalImageBoundsRef.current;
        const naturalWidth = imageSizeRef.current!.naturalWidth;
        const naturalHeight = imageSizeRef.current!.naturalHeight;

        aiAssistedAnnotations!.forEach((annotation) => {
          if (!annotation.projectLabel) {
            return;
          }

          if (annotation.type === "Rectangle") {
            const [left, top, width, height] = annotation.annotation[0]
              .split(",")
              .map(parseFloat);

            const pxLeft = left * naturalWidth;
            const pxTop = top * naturalHeight;
            const pxWidth = width * naturalWidth;
            const pxHeight = height * naturalHeight;

            // Calculate scale from original to scaled image inside canvas
            const scaleX =
              (imageBounds.right - imageBounds.left) / naturalWidth;
            const scaleY =
              (imageBounds.bottom - imageBounds.top) / naturalHeight;

            const canvasLeft = imageBounds.left + pxLeft * scaleX;
            const canvasTop = imageBounds.top + pxTop * scaleY;
            const canvasWidth = pxWidth * scaleX;
            const canvasHeight = pxHeight * scaleY;

            const fillColor = lightenColor(annotation.labelColor, 0);

            // Create Fabric.js rectangle
            const rect = new fabric.Rect({
              left: canvasLeft,
              top: canvasTop,
              width: canvasWidth,
              height: canvasHeight,
              fill: fillColor,
              stroke: "black",
              padding: -(strokeWidth * 1.5),
              strokeWidth: strokeWidth,
              objectCaching: false,
              strokeUniform: true,
              cornerSize: cornerSize,
              selectable: false,
              hasBorders: false,
            }) as CustomRect;

            rect.id = annotation.annotationId;

            fabric.Object.prototype.transparentCorners = false;
            fabric.Object.prototype.cornerColor = "white";
            fabric.Object.prototype.cornerStyle = "circle";
            fabric.Object.prototype.cornerStrokeColor = "black";
            (fabric.Object.prototype as any).cornerStrokeWidth = "3";
            fabric.Rect.prototype._controlsVisibility = {
              mtr: false,
            };

            const label = new fabric.Text(annotation.projectLabel, {
              left: canvasLeft + 4, // Small padding inside the rectangle
              top: canvasTop + 4,
              fontSize: 14,
              fill: "black",
              fontWeight: "bold",
              selectable: false,
              evented: false,
              backgroundColor: "rgba(255,255,255,0.6)",
            });

            // Group the rectangle and the label together (optional for easier movement/management)
            const group = new fabric.Group([rect, label], {
              selectable: false,
            });

            if (modalCanvasRef.current) {
              modalCanvasRef.current.add(rect);
              modalCanvasRef.current.add(group);
              modalCanvasRef.current.renderAll();
            }
          } else if (annotation.type === "Polygon") {
            const data = annotation.annotation[0];
            const dataArray = data.split(",").map(Number);
            const coordinates = [];

            const scaleX =
              (imageBounds.right - imageBounds.left) / naturalWidth;
            const scaleY =
              (imageBounds.bottom - imageBounds.top) / naturalHeight;

            for (let i = 0; i < dataArray.length; i += 2) {
              const normX = dataArray[i] * naturalWidth;
              const normY = dataArray[i + 1] * naturalHeight;

              const canvasX = imageBounds.left + normX * scaleX;
              const canvasY = imageBounds.top + normY * scaleY;

              coordinates.push({ x: canvasX, y: canvasY });
            }

            const fillColor = lightenColor(annotation.labelColor, 0);

            var polygon = new fabric.Polygon(coordinates, {
              fill: fillColor,
              stroke: "black",
              //changed here
              strokeWidth: strokeWidth,
              objectCaching: false,
              transparentCorners: false,
              cornerColor: "yellow",
              strokeUniform: true,
              cornerSize: cornerSize,
              selectable: false,
              perPixelTargetFind: true,
            }) as CustomPolygon;

            polygon.id = annotation.annotationId;

            polygon.setControlsVisibility({
              mtr: false,
            });

            const labelX = coordinates[0].x + 4;
            const labelY = coordinates[0].y + 4;

            const label = new fabric.Text(annotation.projectLabel, {
              left: labelX,
              top: labelY,
              fontSize: 14,
              fill: "black",
              fontWeight: "bold",
              selectable: false,
              evented: false,
              backgroundColor: "rgba(255,255,255,0.6)", // optional
            });

            // Group polygon and label (optional)
            const group = new fabric.Group([polygon, label], {
              selectable: false,
            });

            if (modalCanvasRef.current) {
              modalCanvasRef.current.add(polygon);
              modalCanvasRef.current.add(group);
              modalCanvasRef.current.renderAll();
            }
          }
        });
        setIsAnnotationsLoading(false);
      }
    } catch (error) {
      setIsAnnotationsLoading(false);
      toast.error("Error in loading AI Assisted Annotations");
    }
  };

  // Function to handle closing the dialog
  const handleLabelAssistModelClose = () => {
    setConfidenceValue(10);
    setIsLabelAssistModelopen(false);
  };

  const handleConfidenceValue = (event: Event, newValue: number | number[]) => {
    setConfidenceValue(newValue as number);
    if (labelAssistedImage) {
      const filteredAnnotations = labelAssistedImage.filter(
        (item: any) =>
          selectedAILabels?.includes(item.projectLabel) &&
          item.confidence >= (newValue as number) / 100
      );

      setFilteredlabelAssistedImage(filteredAnnotations);
      loadAIAssistedAnnotations(filteredAnnotations);
    }
  };

  const handleAILabelsChange = (
    event: SelectChangeEvent<typeof selectedAILabels>
  ) => {
    const {
      target: { value },
    } = event;
    setSelectedAILabels(
      typeof value === "string"
        ? value.split(",").filter((v) => v !== "")
        : value
    );

    console.log(
      typeof value === "string"
        ? value.split(",").filter((v) => v !== "")
        : value
    );

    if (labelAssistedImage) {
      const filteredAnnotations = labelAssistedImage.filter(
        (item: any) =>
          value?.includes(item.projectLabel) &&
          item.confidence >= (confidenceValue as number) / 100
      );

      setFilteredlabelAssistedImage(filteredAnnotations);
      loadAIAssistedAnnotations(filteredAnnotations);
    }
  };

  const saveBulkAnnotation = async () => {
    const annotationSaveData = filteredlabelAssistedImage!.map((item: any) => ({
      type: item.type,
      annotation: item.annotation[0],
      annotationId: item.annotationId,
      projectLabelId: item.lableId,
      projectImageId: selectedImageRef.current!.id,
      projectId: id,
    }));

    if (annotationSaveData.length > 0) {
      try {
        setIsAnnotationsLoading(true);
        setIsSaving(true);
        await dispatch(saveBulkImageAnnotation(annotationSaveData))
          .unwrap()
          .then((response) => {
            setIsAnnotationsLoading(false);
            setIsSaving(false);
            loadImageDetails(selectedImageRef.current!.id);
            setIsLabelAssistModelopen(false);
          });
      } catch (e) {
        setIsAnnotationsLoading(false);
        setIsSaving(false);
        toast.error("Failed to save Annotations");
      }
    } else {
      setIsAnnotationsLoading(false);
      setIsSaving(false);
      toast.error("No AI Assisted Annotations are selected");
    }
  };

  return (
    <Box padding="6px 0px 0 0px" sx={{ overflow: "hidden" }}>
      <>
        <img
          src={imageUrl}
          alt="Anno"
          onLoad={handleImageLoad}
          style={{
            display: "none",
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <Box sx={{ background: "#0b2248" }}>
          <Box
            sx={{
              position: "absolute",
              top: "8px",
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Draggable bounds="parent">
              <Box
                sx={{
                  position: "absolute",
                  left: "0",
                  zIndex: "1",
                  display: "flex",
                  gap: "5px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", gap: "10px" }}>
                  <div>
                    <img
                      id="imageBox"
                      src={PhotoGalleryIcon}
                      alt=""
                      style={{
                        height: "30px",
                        /* background: red; */
                        boxShadow: " 0 0 3px grey",
                        marginLeft: "10px",
                        borderRadius: "4px",
                        padding: "3px",
                        cursor: "pointer",
                      }}
                      onClick={() => showImageDrawer(!isGalleryShown)}
                    />
                  </div>
                  <div>
                    <Select
                      sx={{
                        width: "270px",
                        background: "#0000001A",
                        borderRadius: "6px",
                        boxShadow:
                          "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                        color: "#ffffff",

                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                          borderColor: "transparent",
                        },
                      }}
                      value={selectedValue}
                      onChange={handleChange}
                      inputRef={labelRef}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      size="small"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "300px",
                            width: 250,
                            position: "relative",
                          },
                        },
                      }}
                      renderValue={(selected) => {
                        const selectedLabel = labels.find(
                          (label) => label.id === selected
                        );
                        return selectedLabel ? (
                          <Box
                            id="addSelectLabel"
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <span
                              style={{
                                height: "17px",
                                width: "17px",
                                background: selectedLabel.labelColor,
                                borderRadius: "4px",
                                marginRight: "10px",
                                display: "inline-block",
                              }}
                            ></span>
                            <abbr
                              style={{
                                textOverflow: "ellipsis",
                                textDecoration: "none",
                                width: "215px",
                                overflow: "hidden",
                              }}
                            >
                              {selectedLabel.name}
                            </abbr>
                          </Box>
                        ) : (
                          <em>
                            Select/ Add Label
                            {/* {labels.length > 0
                              ? "Select/ Add Label"
                              : "Add Label"} */}
                          </em>
                        );
                      }}
                    >
                      {/* <MenuItem
                        value="button"
                        sx={{
                          display: "block",
                          lineHeight: "2",
                          padding: "0",
                          position: "sticky", // Make this sticky at the bottom
                          top: "0",
                          zIndex: 1,
                        }}
                      >
                        <Box justifyContent="center">
                          <Button
                            variant="contained"
                            onClick={handleButtonClick}
                            sx={{
                              lineHeight: "2",
                              background: "#EEECEC",
                              width: "100%",
                              padding: "10px",
                              color: "#1D97F3",
                              boxShadow: "none",
                              borderRadius: "0", // Ensures background color over other items
                            }}
                            disabled={!isProjectOwner}
                          >
                            + Add Label
                          </Button>
                        </Box>
                      </MenuItem> */}
                      {showDiv && (
                        <div
                          style={{
                            background: "white",
                            position: "sticky",
                            top: "47px",
                            zIndex: "11",
                          }}
                        >
                          <form
                            onSubmit={saveAnnotationLabel}
                            style={{ boxShadow: "0 2px 11px #00000047" }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "17px",
                              }}
                            >
                              <TextField
                                id="standard-basic"
                                label="id"
                                variant="standard"
                                type="hidden"
                                value={selectedProjectLabelIdForEdit}
                              />
                              <span
                                style={{
                                  height: "17px",
                                  width: "17px",
                                  background: selectedColor,
                                  borderRadius: "4px",
                                  marginRight: "10px",
                                }}
                              >
                                <Select
                                  value={selectedColor}
                                  onChange={handleLabelColorChange}
                                  sx={{
                                    padding: "0",
                                    height: "15px",
                                    width: "17px",
                                    border: "none",
                                    "& .MuiInputBase-input": {
                                      border: "none",
                                      padding: "0!important",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                      padding: "0",
                                    },
                                  }}
                                  IconComponent={() => null} // This removes the arrow
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: "150px",
                                        width: 250,
                                      },
                                    },
                                  }}
                                  renderValue={(selected) => {
                                    return (
                                      <span
                                        style={{
                                          flex: "0 0 7%",
                                          height: "17px",
                                          width: "17px",
                                          background: selected,
                                          borderRadius: "4px",
                                          marginRight: "10px",
                                        }}
                                      ></span>
                                    );
                                  }}
                                >
                                  {colorSet.map((color) => (
                                    <MenuItem
                                      key={color.value}
                                      value={color.value}
                                    >
                                      <span
                                        style={{
                                          flex: "0 0 7%",
                                          height: "17px",
                                          width: "17px",
                                          background: color.value,
                                          borderRadius: "4px",
                                          marginRight: "10px",
                                        }}
                                      ></span>
                                      {color.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </span>
                              <input
                                type="text"
                                placeholder="Label Name"
                                onKeyDown={(event) => event.stopPropagation()}
                                value={labelName}
                                onChange={handleLabelNameChange}
                                maxLength={50}
                                style={{
                                  padding: "8px 9px 9px 15px",
                                  fontSize: "16px",
                                  outline: "none",
                                  margin: "5px 0",
                                  width: "85%",
                                  flex: "0 0 75%",
                                  backgroundColor: "#F5F5F5",
                                  border: "1px solid grey",
                                  borderRadius: "4px",
                                }}
                              ></input>
                            </div>
                            {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "17px",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="object-tracking"
                            name="object-tracking"
                            checked={objectTracking}
                            onChange={(e) =>
                              setObjectTracking(e.target.checked)
                            }
                          ></input>
                          <label htmlFor="object-tracking">
                            Object Tracking
                          </label>
                        </div> */}
                            <Box sx={{ padding: "2px" }}>
                              <Button type="submit">Save</Button>
                              <Button onClick={cancelLabelCreation}>
                                Cancel
                              </Button>
                            </Box>
                          </form>
                        </div>
                      )}
                      {labels
                        .filter((label) => label.isDisabled !== true)
                        .map((label) => (
                          <MenuItem
                            value={label.id}
                            id={label.id}
                            key={label.id}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <span
                                  style={{
                                    height: "17px",
                                    width: "17px",
                                    minWidth: "17px",
                                    background: label.labelColor,
                                    borderRadius: "4px",
                                    marginRight: "10px",
                                    display: "inline-block",
                                  }}
                                ></span>
                                <abbr
                                  title={label.name}
                                  style={{
                                    textOverflow: "ellipsis",
                                    textDecoration: "none",
                                    width: "178px",
                                    overflow: "hidden",
                                  }}
                                >
                                  {label.name}
                                </abbr>
                              </Box>
                              {isProjectOwner && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => handleMenuOpen(e, label.id)}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              )}
                            </Box>
                          </MenuItem>
                        ))}
                    </Select>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem onClick={handleEditProjectLabel}>Edit</MenuItem>
                      <MenuItem
                        onClick={() => {
                          setDeleteProjectLabelModal(true);
                          localStorage.setItem("popupOpen", true.toString());
                        }}
                      >
                        Delete
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <Box
                  sx={{
                    // position: "absolute",
                    // bottom: annotationImages.length > 0 ? "70px" : "15px",
                    borderRadius: "6px",
                    width: "100%",
                    textAlign: "center",
                    //zIndex: "99",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  {/* <Draggable bounds="parent"> */}
                  <Box
                    sx={{
                      // background: "#00000066",
                      width: "fit-content",
                      padding: "0",
                      // borderRadius: "6px",
                      // boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                      // position: "relative",
                      zIndex: "999",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleAIButtonClick}
                      // Removed conflicting padding and border-radius classes from className
                      className="text-white font-semibold shadow-md transition duration-300 ease-in-out"
                      sx={{
                        textTransform: "none", // Prevent uppercase text
                        // Converted inline style to sx prop for the 'AI' button
                        backgroundColor: "#0739c2", // Changed from 'background' to 'backgroundColor' for clarity in MUI sx
                        "&:hover": {
                          backgroundColor: "#2563eb", // Darker blue on hover for consistency
                        },
                        borderRadius: "50%", // Set to 50% for a perfect circle
                        width: "36px", // Increased size for better visual appearance
                        height: "36px", // Set height equal to width for roundness
                        minWidth: "unset", // Override MUI's default minWidth for small buttons
                        padding: 0, // Ensure no internal padding interferes with width/height
                        display: "flex", // Use flexbox to center content
                        alignItems: "center", // Center content vertically
                        justifyContent: "center", // Center content horizontally
                        color: "white", // Text color
                        fontWeight: "bold", // Make 'AI' text bold
                        fontSize: "16px", // Adjusted font size for better fit
                        border: "none", // Remove default button border
                        cursor: "pointer", // Indicate it's clickable
                      }}
                    >
                      AI {/* Changed button text to 'AI' */}
                    </Button>
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      Filter By
                    </span>
                    <FormControl
                      id="annotationFilter"
                      sx={{ width: "250px" }}
                      size="small"
                    >
                      <Select
                        labelId="filterByLabel"
                        id="filterByLabel"
                        value={selectedFilter}
                        // label="Filter By Dataset"
                        onChange={handleFilterChange}
                        sx={{
                          height: "38px",
                          background: "#DDE7EB",
                          border: "none", // Remove border for dropdown
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Removes the border from the dropdown
                          },
                          "& .MuiSelect-select": {
                            fontSize: "14px", // Adjust font size of selected text
                            fontWeight: "600",
                            color: "#666666",
                          },
                        }}
                        // InputLabelProps={{
                        //   style: { fontSize: "14px" }, // Adjust the font size here
                        // }}
                      >
                        <MenuItem value="all">
                          All Images({totalImageCount})
                        </MenuItem>
                        <MenuItem
                          value="annotated"
                          disabled={annotatedImgCount === 0}
                        >
                          Annotated Images({annotatedImgCount})
                        </MenuItem>
                        <MenuItem
                          value="unannotated"
                          disabled={unAnnotatedImageCount === 0}
                        >
                          Unannotated Images({unAnnotatedImageCount})
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  {/* </Draggable> */}
                </Box>
              </Box>
            </Draggable>

            <Box
              sx={{
                // display: "flex", gap: "10px",
                zIndex: "999",
                top: "186px",
                left: isGalleryShown ? "330px" : "0",
                transition: "left 0.5s",
                position: "absolute",
              }}
            >
              {selectedImageRef.current &&
                (selectedImageRef.current!.isAnnotator || isProjectOwner) && (
                  <Box
                    sx={{
                      background: "#00000033",
                      borderRadius: "4px",
                      boxShadow: "0 20px 0px 31px #00000022 inset",
                      marginBottom: "20px",
                    }}
                  >
                    <Tooltip title="Select" placement="right" arrow>
                      <span>
                        <Button
                          id="select"
                          disabled={labels.length > 0 ? false : true}
                          sx={
                            selectedTool === "select" && labels.length > 0
                              ? {
                                  background: "black",
                                  boxShadow: "0 20px 0px 31px #00000022 inset",
                                  border: "0.5px solid white",
                                  minWidth: "40px",
                                  display: "block",
                                  lineHeight: "0",
                                }
                              : {
                                  display: "block",
                                  lineHeight: "0",
                                  color: "white",
                                  minWidth: "40px",
                                  cursor:
                                    labels.length > 0
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity: labels.length > 0 ? "1" : "0.5",
                                }
                          }
                          onClick={() => handleClick("select")}
                        >
                          {/* <img
                    src={select}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      objectFit: "contain",
                    }}
                  /> */}
                          <NavigationOutlined
                            sx={{
                              color: "#ffffff",
                              height: "24px",
                              width: "24px",
                              transform: "rotate(-37deg)",
                            }}
                          />
                        </Button>
                      </span>
                    </Tooltip>
                    {!(
                      taskTypes === "4577f6ce-b2b0-4cb6-9b55-c3968dc9f5b3" ||
                      taskTypes === "92b49262-571d-4dbf-b13b-ffb4529e76e4"
                    ) && (
                      <Tooltip title="Rectangle" placement="right" arrow>
                        <span>
                          <Button
                            id="addRectangle"
                            disabled={labels.length > 0 ? false : true}
                            sx={
                              selectedTool === "rect"
                                ? {
                                    background: "black",
                                    boxShadow:
                                      "0 20px 0px 31px #00000022 inset",
                                    border: "0.5px solid white",
                                    minWidth: "40px",
                                    display: "block",
                                    lineHeight: "0",
                                  }
                                : {
                                    display: "block",
                                    lineHeight: "0",
                                    color: "white",
                                    minWidth: "40px",
                                    cursor:
                                      labels.length > 0
                                        ? "pointer"
                                        : "not-allowed",
                                    opacity: labels.length > 0 ? "1" : "0.5",
                                  }
                            }
                            onClick={() => handleClick("rect")}
                          >
                            {/* <img
                              src={Rect}
                              alt=""
                              style={{
                                height: "20px",
                                width: "20px",
                                objectFit: "contain",
                              }}
                            /> */}
                            <RectangleOutlined
                              sx={{
                                color: "#ffffff",
                                height: "24px",
                                width: "24px",
                              }}
                            />
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    <Tooltip title="Polygon" placement="right" arrow>
                      <span>
                        <Button
                          id="addPolygon"
                          disabled={labels.length > 0 ? false : true}
                          sx={
                            selectedTool === "poly"
                              ? {
                                  background: "black",
                                  boxShadow: "0 20px 0px 31px #00000022 inset",
                                  border: "0.5px solid white",
                                  minWidth: "40px",
                                  display: "block",
                                  lineHeight: "0",
                                }
                              : {
                                  display: "block",
                                  lineHeight: "0",
                                  color: "white",
                                  minWidth: "40px",
                                  cursor:
                                    labels.length > 0
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity: labels.length > 0 ? "1" : "0.5",
                                }
                          }
                          onClick={() => handleClick("poly")}
                        >
                          {/* <img
                    src={Polygon}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      objectFit: "contain",
                    }}
                  /> */}
                          <HexagonOutlined
                            sx={{
                              color: "#ffffff",
                              height: "24px",
                              width: "24px",
                            }}
                          />
                        </Button>
                      </span>
                    </Tooltip>
                    <Tooltip title="Magic Wand" placement="right" arrow>
                      <span>
                        <Button
                          id="magicWand"
                          disabled={labels.length > 0 ? false : true}
                          sx={
                            selectedTool === "magicWand"
                              ? {
                                  background: "black",
                                  boxShadow: "0 20px 0px 31px #00000022 inset",
                                  border: "0.5px solid white",
                                  minWidth: "40px",
                                  display: "block",
                                  lineHeight: "0",
                                }
                              : {
                                  display: "block",
                                  lineHeight: "0",
                                  color: "white",
                                  minWidth: "40px",
                                  cursor:
                                    labels.length > 0
                                      ? "pointer"
                                      : "not-allowed",
                                  opacity: labels.length > 0 ? "1" : "0.5",
                                }
                          }
                          onClick={() => handleClick("magicWand")}
                        >
                          <img
                            src={MagicWand}
                            alt=""
                            style={{
                              height: "20px",
                              width: "20px",
                              objectFit: "contain",
                            }}
                          />
                        </Button>
                      </span>
                    </Tooltip>
                  </Box>
                )}
              <Box
                sx={{
                  background: "#00000033",
                  borderRadius: "4px",
                  boxShadow: "0 20px 0px 31px #00000022 inset",
                }}
              >
                <Tooltip title="Pan" placement="right" arrow>
                  <span>
                    <Button
                      id="pan"
                      sx={
                        selectedTool === "pan"
                          ? {
                              background: "black",
                              boxShadow: "0 20px 0px 31px #00000022 inset",
                              border: "0.5px solid white",
                              minWidth: "35px",
                              cursor: zoomLevel > 1 ? "pointer" : "not-allowed",
                              opacity: zoomLevel > 1 ? "1" : "0.5",
                              display: "block",
                              lineHeight: "0",
                            }
                          : {
                              display: "block",
                              lineHeight: "0",
                              color: "white",
                              minWidth: "35px",
                              cursor: zoomLevel > 1 ? "pointer" : "not-allowed",
                              opacity: zoomLevel > 1 ? "1" : "0.5",
                            }
                      }
                      onClick={() => handleClick("pan")}
                      disabled={zoomLevel > 1 ? false : true}
                    >
                      <BackHandOutlined
                        sx={{ color: "#ffffff", height: "24px", width: "24px" }}
                      />
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip title="Zoom In" placement="right" arrow>
                  <Button
                    sx={{
                      color: "white",
                      minWidth: "40px",
                      display: "flex",
                    }}
                    id="zoomIn"
                  >
                    <img
                      src={ZoomIn}
                      alt=""
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Zoom out" placement="right" arrow>
                  <Button
                    sx={{
                      color: "white",
                      minWidth: "40px",
                      display: "flex",
                    }}
                    id="zoomOut"
                  >
                    <img
                      src={ZoomOut}
                      alt=""
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Reset" placement="right" arrow>
                  <Button sx={{ color: "white", minWidth: "40px" }} id="reset">
                    <img
                      src={Reset}
                      alt=""
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </Box>
          {annotationImages.length > 0 ? (
            <Box
              id="annotationFilter"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                overflow: "visible",
                // width: containerWidth,
                // margin: "0 auto",
                height: "47px",
                gap: "10px",
                width: "100%",
                background: "#f7f7f7",
              }}
            >
              {/* Left Button */}
              <Box
                sx={{
                  position: "absolute",
                  left: "47%",
                  padding: "0px",
                  transition: `bottom 0.5s ease-in-out`,
                  // bottom: isClickedArrow ? "58px" : "4px",
                  zIndex: "99",
                }}
              >
                {/* <Box>
                  <Typography
                    sx={{
                      background: "white",
                      borderTopLeftRadius: "30px",
                      borderTopRightRadius: "30px",
                      textAlign: "center",
                      margin: "0",
                      height: "17px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsClickedArrow((prevState) => !prevState)}
                  >
                    <KeyboardArrowUpIcon
                      sx={{
                        rotate: isClickedArrow ? "180deg" : "",
                        height: "17px",
                      }}
                    />
                  </Typography>
                </Box> */}
              </Box>

              {/* Image Slider Track */}
            </Box>
          ) : (
            <div
              className={isGalleryShown ? "toggled" : "not-toggled"}
              style={{
                alignContent: "center",
                textAlign: "center",
                background: "rgb(131 131 131 / 68%)",
                position: "absolute",
                zIndex: "999",
                padding: "10px",
                top: "49px",
                left: "10px",
                width: "300px",
                height: "calc(100vh - 176px)",
                borderRadius: "12px",
              }}
            >
              <p>No Images</p>
            </div>
          )}
          {annotationImages.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                position: "relative",
                justifyContent: "flex-end",
              }}
            >
              <div
                className={isGalleryShown ? "toggled" : "not-toggled"}
                ref={observerRef}
                onScroll={handleScroll}
                style={{
                  background: "#414749ad",
                  position: "absolute",
                  overflow: "scroll",
                  zIndex: "999",
                  padding: "10px",
                  top: "5px",
                  left: "10px",
                }}
              >
                <Box
                  sx={{
                    // position: "absolute",
                    bottom: annotationImages.length > 0 ? "3px" : "3px",
                    borderRadius: "6px",
                    // width: "100%",
                    // textAlign: "center",
                    // //zIndex: "99",
                    // justifyContent: "center",
                    right: "10px",
                    // display: "flex",
                    // gap: "5px",
                    alignItems: "center",
                    position: "sticky",
                    top: "0",
                    zIndex: "9",
                  }}
                >
                  {/* <Draggable bounds="parent"> */}

                  {/* </Draggable> */}
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    // overflow: "scroll",
                    gridTemplateColumns: "repeat(2, 1fr)",

                    gap: "6px",
                    // background: "#212D32B2",
                    // scrollbarWidth: "none",
                    // msOverflowStyle: "none",

                    // "&::-webkit-scrollbar": {
                    //   display: "none",
                    // },
                  }}
                  // id="imageContainer"
                  // sx={{
                  //   display: "flex",
                  //   transition: `transform 0.5s ease-in-out`, // Keep the original transition for sliding
                  //   transform: `translateX(calc(49.6% - ${
                  //     currentIndex * imageWidth
                  //   }px - ${imageWidth / 2}px))`,
                  //   width: "fit-content",
                  //   zIndex: 0,
                  //   // gap: "3px",
                  // }}
                >
                  {annotationImages.map((item, index) => (
                    <Box
                      key={index}
                      data-index={index}
                      sx={{
                        position: "relative",
                        height: "fit-content",
                        width: "100%",
                        margin: "auto",
                        // marginLeft: index === 0 ? "45.5%" : "",
                        // marginRight:
                        // index === annotationImages.length - 1 ? "50%" : "",
                      }}
                      // Adjust z-index based on hover state
                      // sx={{
                      //   minWidth:
                      //     index === currentIndex
                      //       ? `${imageWidth + 22}px`
                      //       : `${imageWidth}px`,
                      //   transition: "min-width 0.3s ease, transform 0.3s ease", // Add smooth transition for size changes
                      //   transform:
                      //     index === currentIndex ? "scale(1.1)" : "scale(1)", // Slightly scale up the selected image
                      // }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          bottom: "8px",
                          fontSize: "10px",
                          color: "white",
                          background: "black",
                          padding: "1px 2px",
                          // display:
                          //   index === currentIndex ? "none" : "inline-block",
                          left: "0px",
                          opacity: "1",
                          zIndex: "1",
                        }}
                      >
                        {item.annotationsCount}
                      </span>
                      <img
                        src={`${process.env.REACT_APP_SERVER_BASEURL}${item.thumbUrl}`}
                        alt=""
                        onClick={() => handleImageSelection(index)}
                        style={{
                          width: index === currentIndex ? "95%" : "100%",
                          height: index === currentIndex ? "92px" : "100px",
                          objectFit: "fill",
                          // opacity: index === currentIndex ? "1" : "0.7",
                          cursor: "pointer",
                          // padding: index === currentIndex ? "0" : "6px 0px",
                          border:
                            index === currentIndex ? "4px solid white" : "none",
                          borderRadius: index === currentIndex ? "4px" : "0px",
                          background: "#212D32B2",
                          //   transition: "opacity 0.3s ease, transform 0.3s ease", // Transition for opacity and image scaling
                          //   marginRight:
                          //     index === currentIndex - 1 ? "60px" : "0px",
                          //   marginLeft:
                          //     index === currentIndex + 1
                          //       ? "60px"
                          //       : index === currentIndex - 1
                          //       ? "-60px"
                          //       : "0px",
                          marginTop: "2px",
                          position: "relative",
                        }}
                      />
                      {item.isAnnotated && (
                        <span
                          style={{
                            width: "12px",
                            textAlign: "center",
                            alignContent: "center",
                            height: "12px",
                            borderRadius: "50%",
                            top: "9px",
                            position: "absolute",
                            right: "4px",
                            fontSize: "8px",
                            background: "green",
                            color: "white",
                            // display:
                            //   index === currentIndex ? "none" : "inline-block",
                            opacity: "1",
                          }}
                        >
                          <img
                            src={TickMark}
                            alt=""
                            style={{
                              height: "6px",
                              width: "auto",
                              objectFit: "contain",
                            }}
                          />
                        </span>
                      )}
                    </Box>
                  ))}
                </Box>
                {isLoading && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      justifyContent: "center",
                    }}
                  >
                    <div className="imageloader"></div>
                    <p style={{ color: "white", fontSize: "14px" }}>
                      Loading...
                    </p>
                  </div>
                )}
              </div>

              <div
                style={{
                  width: isGalleryShown
                    ? isPinned
                      ? "calc(100vw - 700px)" // If isGalleryShown and isOpen, set width to 56%
                      : "calc(100vw - 485px)" // If isGalleryShown but not isOpen, set width to 71%
                    : isPinned
                    ? "79%" // If isGalleryShown is false and isOpen is true, set width to 79%
                    : "100%", // If neither isGalleryShown nor isOpen, set width to 100%
                  height: "calc(100vh - 154px)",
                  transition: "width 0.7s, margin-right 0.7s",
                  position: "relative",
                  marginRight: isPinned ? "215px" : "",
                }}
              >
                {/* <Box sx={{ zIndex: "99" }}>
                  <FilterListIcon
                    sx={{
                      height: "22px",
                      border: "1px solid white",
                      padding: "1px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      color: "white",
                      background: "grey",
                    }}
                    // onClick={() => setIsFiltered(!isFiltered)}
                  />
                </Box> */}

                <Box sx={{ position: "absolute", top: "-41px", left: "45%" }}>
                  <Box
                    id="selectImage"
                    sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        zIndex: 1, // Ensure buttons are on top
                        minWidth: "30px",
                        // background: "#e1e1e1",
                        height: "30px",
                        // border: "1px solid #656565",
                        padding: "0",

                        borderRadius: "4px",
                      }}
                      onClick={handlePrevious}
                      disabled={currentIndex === 0}
                    >
                      <NavigateBeforeOutlinedIcon />
                    </Button>
                    <div>
                      <Typography sx={{ fontSize: "14px" }}>
                        <span style={{ fontWeight: "bold" }}>
                          {currentIndex + 1}
                        </span>{" "}
                        /{" "}
                        {selectedFilter === "all"
                          ? totalImageCount
                          : selectedFilter === "annotated"
                          ? annotatedImgCount
                          : unAnnotatedImageCount}
                      </Typography>
                    </div>
                    {/* <div
                      style={{
                        zIndex: 10,
                        width: `${imageWidth + 22}px`,
                        height: "55px",
                        borderRadius: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                        pointerEvents: "none",
                        background: "#656565",
                      }}
                    >
                      {annotationImages[currentIndex] && (
                        <img
                          src={`${process.env.REACT_APP_SERVER_BASEURL}${annotationImages[currentIndex].thumbUrl}`}
                          alt="Selected"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",
                            border: "3px solid #656565",
                            borderRadius: "4px",
                            background: "#212D32B2",
                          }}
                        />
                      )}
                    </div> */}
                    {/* Right Button */}
                    <Button
                      variant="contained"
                      sx={{
                        zIndex: 1,
                        minWidth: "30px",
                        height: "30px",
                        padding: "0",
                        borderRadius: "4px",
                        color: "white",
                      }}
                      onClick={handleNext}
                      disabled={currentIndex === annotationImages.length - 1}
                    >
                      <NavigateNextOutlinedIcon />
                    </Button>
                  </Box>
                </Box>

                <div className="crosshair-div">
                  <div id="crosshair-h" className="hair"></div>
                  <div id="crosshair-v" className="hair"></div>
                  <canvas
                    id="canvasId"
                    ref={canvasElementRef}
                    style={{ width: "100%", height: "100%" }}
                  ></canvas>
                </div>
              </div>
              <Box
                sx={{
                  background: "white",
                  position: "relative",
                  zIndex: "99",
                }}
                component="div"
                onClick={() => setIsOpen(!isOpen)}
              >
                <Box sx={{ textAlign: "right" }}>
                  <IconButton
                    onClick={handlePin}
                    aria-label="delete"
                    sx={{
                      boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                      background: isPinned ? "#1D1D51" : "#0000001A",
                      borderRadius: "0",
                      "&:hover": {
                        background: isPinned ? "#1D1D51" : "#0000001A",
                      },
                    }}
                  >
                    <PushPinIcon
                      sx={{
                        transform: "rotate(45deg)",
                        color: isPinned ? "white" : "",
                      }}
                    />
                  </IconButton>
                </Box>
                {getLastThreeLabels().map((label) => {
                  return (
                    <Box
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        padding: "14px",
                        borderRadius: "2px",
                        marginTop: "6px",
                      }}
                    >
                      <Box>
                        <span
                          style={{
                            height: "15px",
                            width: "15px",
                            background: label.color,
                            display: "block",
                            margin: "auto",
                            borderRadius: "3px",
                          }}
                        ></span>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            textAlign: "center",
                            marginTop: "3px",
                          }}
                        >
                          {label.label}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
                {labelDetails.length > 0 && (
                  <Box
                    sx={{
                      boxShadow: "0px 4px 4px 0px #00000040",
                      padding: "10px",
                      borderRadius: "2px",
                      marginTop: "6px",
                      textAlign: "center",
                    }}
                  >
                    <MoreHorizIcon
                    // onClick={() => setIsOpen(!isOpen)}
                    />
                  </Box>
                )}
                <Box
                  sx={{
                    position: "absolute",
                    right: isOpen ? "250px" : "43px",
                    top: "50%",
                  }}
                >
                  <IconButton
                    //onClick={() => setIsOpen(!isOpen)}
                    aria-label="delete"
                    sx={{
                      background:
                        "linear-gradient(92.07deg, rgba(15, 29, 51, 0.4) 8.89%, rgba(255, 255, 255, 0) 175.2%)",
                      borderRadius: "3px",
                    }}
                  >
                    <KeyboardDoubleArrowLeftIcon
                      id="anotatedLabel"
                      sx={{
                        transform: isOpen ? "rotate(180deg)" : "",
                        color: "white",
                      }}
                    />
                  </IconButton>
                </Box>
              </Box>
              <Box
                id="annotatePin"
                sx={{
                  position: "absolute",
                  right: "41px",
                  zIndex: "999",
                  minHeight: "41px",
                }}
              ></Box>
              {isOpen && (
                <Box
                  ref={drawerRef}
                  sx={{
                    width: "250px",
                    position: "absolute",
                    right: "0",
                    background: "white",
                    height: "100%",
                    zIndex: "99",
                    transition: "width 0.5s ease-in",
                  }}
                >
                  <Box sx={{ textAlign: "right" }}>
                    <IconButton
                      onClick={handlePin}
                      aria-label="delete"
                      sx={{
                        boxShadow:
                          "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                        background: isPinned ? "#1D1D51" : "#0000001A",
                        borderRadius: "0",
                        "&:hover": {
                          background: isPinned ? "#1D1D51" : "#0000001A",
                        },
                      }}
                    >
                      <PushPinIcon
                        sx={{
                          transform: "rotate(45deg)",
                          color: isPinned ? "white" : "",
                        }}
                      />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{
                      overflow: "scroll",
                      height: "calc(-205px + 100vh)",
                      padding: "0 15px",
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: "20px",
                        fontWeight: "500",
                        margin: "20px 0",
                      }}
                    >
                      Annotated Labels
                    </Typography>
                    {labelDetails?.map((label, index) => (
                      <Box key={index}>
                        <Typography
                          key={label.index}
                          variant="h4"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontSize: "14px",
                          }}
                        >
                          {getColorName(label.color)} (
                          {label.labelProperties.length})
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            {label.labelProperties.every(
                              (labelProp) => labelProp.isChecked
                            ) &&
                              selectedImageRef.current! &&
                              (selectedImageRef.current.isAnnotator ||
                                isProjectOwner) && (
                                <CloseIcon
                                  onClick={() =>
                                    handleDeleteAllAnnotationModalOpen()
                                  }
                                  sx={{
                                    fontSize: "20px",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            <Checkbox
                              id="anotatedLabelGroup"
                              size="small"
                              sx={{ padding: "0" }}
                              checked={label.labelProperties.every(
                                (label) => label.isChecked
                              )}
                              onChange={(e) =>
                                handleSelectAll(index, e.target.checked)
                              }
                            />
                          </span>
                        </Typography>
                        <Box>
                          {isAnnoSaving &&
                            label.labelProperties.some(
                              (item) => item.labelId === selectedLabel.value
                            ) && (
                              <ListItem
                                sx={{
                                  margin: "5px 0",
                                  borderRadius: "4px",
                                  justifyContent: "center",
                                  background: "#35383e24",
                                  // opacity: "0",
                                  // transform: "translateX(-100%)",
                                  // transition:
                                  //   "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
                                  "&:hover": {
                                    background: "#35383e24",
                                    //   opacity: "1",
                                    //   transform: "translateX(0)",
                                  },
                                  cursor: "pointer",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "13px",
                                    textWrap: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    margin: "0",
                                  }}
                                >
                                  <span className="loader"></span>
                                </p>
                              </ListItem>
                            )}
                          <List>
                            {label.labelProperties.map((labelProperty) => {
                              return (
                                <ListItem
                                  key={labelProperty.annotationId}
                                  onClick={() =>
                                    selectAnnotationonLabelClick(labelProperty)
                                  }
                                  sx={{
                                    background:
                                      labelProperty.isChecked ||
                                      labelProperty.annotationId ===
                                        selectedAnnotationId
                                        ? "#35383e36"
                                        : "#35383E0D",
                                    boxShadow:
                                      selectedAnnotationId ===
                                      labelProperty.annotationId
                                        ? "0 0 2px #00000030"
                                        : "",
                                    margin: "5px 0",
                                    borderRadius: "4px",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    "&:hover": {
                                      background: "#35383e24",
                                      "& .close-icon": {
                                        display: "block!important",
                                      },
                                    },
                                    cursor: "pointer",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      textWrap: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <span
                                      style={{
                                        height: "10px",
                                        width: "10px",
                                        background: label.color,
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        marginRight: "10px",
                                      }}
                                    ></span>
                                    <abbr
                                      title={labelProperty.labelName}
                                      style={{ textDecoration: "none" }}
                                    >
                                      {labelProperty.labelName}
                                    </abbr>
                                  </Typography>
                                  <span
                                    className="close-icon"
                                    style={{
                                      display:
                                        selectedAnnotationId ===
                                        labelProperty.annotationId
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    {selectedImageRef.current &&
                                      (selectedImageRef.current.isAnnotator ||
                                        isProjectOwner) && (
                                        <CloseIcon
                                          onClick={() =>
                                            handleDeleteAnnotationModalOpen(
                                              labelProperty.annotationId
                                            )
                                          }
                                          sx={{
                                            fontSize: "12px",
                                            color: "red",
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                  </span>
                                </ListItem>
                              );
                            })}
                          </List>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          ) : isImagesLoaded && annotationImages.length === 0 ? (
            <Box sx={{ height: "calc(100vh - 160px)", alignContent: "center" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  color: "#ff000080",
                  margin: "10px",
                }}
              >
                No Images Available
                <br />
                <span style={{ color: "#00000080", fontSize: "16px" }}>
                  {selectedFilter === "all"
                    ? "Please Upload images to annotate"
                    : selectedFilter === "annotated"
                    ? "Start Annotating the images"
                    : "All the images are Annotated"}
                </span>
              </p>
            </Box>
          ) : (
            <Box sx={{ height: "calc(100vh - 160px)", alignContent: "center" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  color: "#ff000080",
                  margin: "10px",
                }}
              >
                Loading Images...
                <br />
              </p>
            </Box>
          )}
          <Dialog
            open={deleteAnnotationModal}
            onClose={handleDeleteAnnotationModalClose}
            PaperProps={{
              style: {
                boxShadow: "none",
                width: "50%",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "#2121210f",
                },
              },
            }}
          >
            <DialogTitle>Delete Annotation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to delete this Annotation?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteAnnotationModalClose}>Cancel</Button>
              <Button
                // type="submit"
                onClick={deleteAnnotationById}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={deleteAllAnnotationModal}
            onClose={() => setDeleteAllAnnotationModal(false)}
            PaperProps={{
              style: {
                boxShadow: "none",
                width: "50%",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "#2121210f",
                },
              },
            }}
          >
            <DialogTitle>Delete All Annotation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to delete all Annotation of selected colour?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDeleteAllAnnotationModal(false)}>
                Cancel
              </Button>
              <Button onClick={deleteAllAnnotationById}>Delete All</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={deleteProjectLabelModal}
            onClose={() => {
              setDeleteProjectLabelModal(false);
              localStorage.setItem("popupOpen", false.toString());
            }}
            PaperProps={{
              style: {
                boxShadow: "none",
                width: "50%",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "#2121210f",
                },
              },
            }}
          >
            <DialogTitle>Delete Project Label</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you want to delete this Label?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button id="calcelDeleteLabel" onClick={handleDeleteLabelClose}>
                Cancel
              </Button>
              <Button
                id="confirmDeleteLabel"
                onClick={handleProjectLabelDelete}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
        <Dialog
          open={maxLabelCount}
          onClose={handleMaxLabelCountClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              boxShadow: "none",
              width: "50%",
            },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: "#2121210f",
              },
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            Maximum Limit Reached
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ padding: "10px 0" }}
            >
              Oops! Your current plan supports a maximum of{" "}
              <b>{maxLableLimit}</b> labels. Upgrade to add more labels!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleMaxLabelCountClose} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleRedirectPlanPage}
              variant="contained"
              color="error"
            >
              I want more Labels @ $9
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          disableEscapeKeyDown
          open={isLabelAssistModelopen}
          onClose={handleLabelAssistModelClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            // Combined user's style and existing className/sx for PaperProps
            className: "rounded-xl shadow-2xl p-6 w-full mx-auto", // Keep Tailwind classes
            sx: {
              boxShadow: "none", // User's requested shadow removal
              width: "100%", // User's requested width
              maxWidth: "100%", // Ensure responsiveness and max width
              borderRadius: "1rem", // Existing rounded corners
              height: "95%",
              maxHeight: "95%",
            },
          }}
          slotProps={{
            backdrop: {
              sx: {
                // User's requested gray background with 0.5 opacity
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          }}
        >
          {/* Loader Overlay */}
          {isAnnotationsLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "1rem",
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleLabelAssistModelClose}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.1)",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.2)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
                <Typography
                  variant="body1"
                  sx={{
                    marginTop: 2,
                    color: "#333",
                    fontWeight: 500,
                    fontSize: "16px",
                    textAlign: "center",
                  }}
                >
                  {isSaving
                    ? "Saving Annotation"
                    : "Loading AI assisted Annotations"}
                </Typography>
              </Box>
            </Box>
          )}
          <DialogTitle className="text-2xl font-bold text-gray-900 pb-4 border-b border-gray-200">
            AI Model Assist Results
          </DialogTitle>
          <DialogContent sx={{ paddingBottom: "1px" }} className="py-6">
            <Box
              sx={{
                display: "flex",
                alignItems: "clefenter",
                gap: 2,
                mb: 0.1,
                flexWrap: "nowrap",
              }}
            >
              <Grid
                container // Use container for Grid layout
                item // This Grid is an item within the DialogContent
                xs={6}
              >
                <Typography variant="h6" sx={{ flexShrink: 0 }}>
                  {modelName}
                </Typography>
              </Grid>
              {/* 2. Label and Select Option */}
              <Grid
                container // Use container for Grid layout
                item // This Grid is an item within the DialogContent
                xs={3}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  order: 4, // This order might not be strictly necessary here as it's a direct child
                  height: "100%", // Full height to allow vertical spacing
                  marginTop: "1px", // Add some margin from the above row
                }}
              >
                <Typography
                  variant="subtitle1" // Smaller text for label
                  component="span"
                  sx={{ marginBottom: "1px", fontSize: "13px" }}
                >
                  Select Label
                </Typography>
                <FormControl sx={{ minWidth: 120, flexGrow: 1 }}>
                  <Select
                    multiple
                    labelId="select-option-label"
                    id="select-option"
                    value={selectedAILabels}
                    onChange={handleAILabelsChange}
                    label="Select Label"
                    size="small"
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: "300px",
                          width: 250,
                          position: "relative",
                        },
                      },
                    }}
                    sx={{
                      width: "270px",
                      background: "#0000001A",
                      borderRadius: "6px",
                      boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                      color: "#ffffff",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        borderColor: "transparent",
                      },
                    }}
                    renderValue={(selected) => selected!.join(", ")} // Optional: how selected values are shown
                  >
                    {AIAssistedLabels &&
                      AIAssistedLabels.map((label) => (
                        <MenuItem key={label} value={label}>
                          <Checkbox
                            checked={selectedAILabels!.indexOf(label) > -1}
                          />
                          <ListItemText primary={label} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              {/* 3. Progress Bar */}
              {/* New Slider Section */}
              <Grid
                container
                item
                xs={3}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  order: 4,
                  height: "100%",
                  marginTop: "1px",
                }}
              >
                <Typography
                  variant="subtitle1" // Smaller text for label
                  component="span"
                  sx={{ marginBottom: "1px", fontSize: "13px" }}
                >
                  Confidence Threshold
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  <Slider
                    value={confidenceValue} // Bind value to state
                    onChange={handleConfidenceValue} // Standard onChange handler
                    //ref={sliderRef}
                    aria-labelledby="input-slider"
                    min={10}
                    max={100} // Set a max value for the slider
                    sx={{ flex: 1, marginRight: "10px" }} // Flex to take remaining space
                  />
                  <Box
                    sx={{
                      background: "#1D97F3",
                      color: "#fff",
                      padding: "5px",
                      borderRadius: "40%", // Use 50% for perfect circle if width/height are equal
                      minWidth: "30px", // Ensure enough space for text
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    {confidenceValue}%
                  </Box>
                </Box>
              </Grid>
            </Box>
            {/* Middle Image */}
            <Box
              sx={{
                position: "absolute",
                zIndex: "99999",
                width: "40px",
                background: "#3b3b3bb8",
                borderRadius: "4px",
                boxShadow: "0 20px 0px 31px #00000022 inset",
              }}
            >
              {/* <Tooltip title="Pan" placement="right" arrow>
                <span>
                  <Button
                    id="modalPan"
                    sx={
                      selectedTool === "pan"
                        ? {
                            background: "black",
                            boxShadow: "0 20px 0px 31px #00000022 inset",
                            border: "0.5px solid white",
                            minWidth: "35px",
                            cursor: zoomLevel > 1 ? "pointer" : "not-allowed",
                            opacity: zoomLevel > 1 ? "1" : "0.5",
                            display: "block",
                            lineHeight: "0",
                          }
                        : {
                            display: "block",
                            lineHeight: "0",
                            color: "white",
                            minWidth: "35px",
                            cursor: zoomLevel > 1 ? "pointer" : "not-allowed",
                            opacity: zoomLevel > 1 ? "1" : "0.5",
                          }
                    }
                    onClick={() => handleClick("pan")}
                    disabled={zoomLevel > 1 ? false : true}
                  >
                    <BackHandOutlined
                      sx={{ color: "#ffffff", height: "24px", width: "24px" }}
                    />
                  </Button>
                </span>
              </Tooltip> */}
              <Tooltip title="Zoom In" placement="right" arrow>
                <Button
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    display: "block",
                  }}
                  id="modalZoomIn"
                  onClick={() => {
                    if (modalZoomInRef.current) {
                      modalZoomInRef.current();
                    }
                  }}
                >
                  <img
                    src={ZoomIn}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      objectFit: "contain",
                    }}
                  />
                </Button>
              </Tooltip>
              <Tooltip title="Zoom out" placement="right" arrow>
                <Button
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    display: "block",
                  }}
                  id="modalZoomOut"
                  onClick={() => {
                    if (modalZoomOutRef.current) {
                      modalZoomOutRef.current();
                    }
                  }}
                >
                  <img
                    src={ZoomOut}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      objectFit: "contain",
                    }}
                  />
                </Button>
              </Tooltip>
              <Tooltip title="Reset" placement="right" arrow>
                <Button
                  sx={{ color: "white", minWidth: "40px" }}
                  id="modalReset"
                  onClick={() => {
                    if (modalResetZoomRef.current) {
                      modalResetZoomRef.current();
                    }
                  }}
                >
                  <img
                    src={Reset}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      objectFit: "contain",
                    }}
                  />
                </Button>
              </Tooltip>
            </Box>
            <Box
              id="canvaDivId"
              sx={{
                position: "absolute",
                marginTop: "5px",
                paddingLeft: "25px",
                textAlign: "center",
                width: "96%",
                height: "506px !important",
                overflow: "auto",
              }}
            >
              <canvas
                id="modalCanvasId"
                ref={modalCanvasElementRef}
                style={{
                  position: "absolute",
                  height: "506px",
                  width: "100%",
                  display: "block",
                }}
              ></canvas>
            </Box>
            {/* Original Dialog Content Text (optional, can be removed if not needed) */}
          </DialogContent>
          {/* Dialog Actions (buttons at the bottom) */}
          <DialogActions className="pt-4 border-t border-gray-200 flex justify-end gap-3">
            <Button
              onClick={handleLabelAssistModelClose}
              className="text-blue-600 hover:text-blue-800 font-semibold py-2 px-4 rounded-lg transition duration-200 ease-in-out"
              sx={{ textTransform: "none", borderRadius: "0.5rem" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm transition duration-200 ease-in-out"
              sx={{ textTransform: "none", borderRadius: "0.5rem" }}
              autoFocus // Automatically focuses this button when the dialog opens
              onClick={saveBulkAnnotation}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </Box>
  );
};

export default withSpinner(Annotate);
